import { s as ze, o as ye } from "./default-C3m3V4yx.js";
const Ut = {};
function Qt(e, i) {
  const t = i || Ut, n = typeof t.includeImageAlt == "boolean" ? t.includeImageAlt : !0, c = typeof t.includeHtml == "boolean" ? t.includeHtml : !0;
  return pt(e, n, c);
}
function pt(e, i, t) {
  if ($t(e)) {
    if ("value" in e)
      return e.type === "html" && !t ? "" : e.value;
    if (i && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return Ge(e.children, i, t);
  }
  return Array.isArray(e) ? Ge(e, i, t) : "";
}
function Ge(e, i, t) {
  const n = [];
  let c = -1;
  for (; ++c < e.length; )
    n[c] = pt(e[c], i, t);
  return n.join("");
}
function $t(e) {
  return !!(e && typeof e == "object");
}
const Je = document.createElement("i");
function Be(e) {
  const i = "&" + e + ";";
  Je.innerHTML = i;
  const t = Je.textContent;
  return t.charCodeAt(t.length - 1) === 59 && e !== "semi" || t === i ? !1 : t;
}
function Y(e, i, t, n) {
  const c = e.length;
  let r = 0, o;
  if (i < 0 ? i = -i > c ? 0 : c + i : i = i > c ? c : i, t = t > 0 ? t : 0, n.length < 1e4)
    o = Array.from(n), o.unshift(i, t), e.splice(...o);
  else
    for (t && e.splice(i, t); r < n.length; )
      o = n.slice(r, r + 1e4), o.unshift(i, 0), e.splice(...o), r += 1e4, i += 1e4;
}
function G(e, i) {
  return e.length > 0 ? (Y(e, e.length, 0, i), e) : i;
}
const Xe = {}.hasOwnProperty;
function gt(e) {
  const i = {};
  let t = -1;
  for (; ++t < e.length; )
    Zt(i, e[t]);
  return i;
}
function Zt(e, i) {
  let t;
  for (t in i) {
    const n = (Xe.call(e, t) ? e[t] : void 0) || (e[t] = {}), c = i[t];
    let r;
    if (c)
      for (r in c) {
        Xe.call(n, r) || (n[r] = []);
        const o = c[r];
        Kt(n[r], Array.isArray(o) ? o : o ? [o] : []);
      }
  }
}
function Kt(e, i) {
  let t = -1;
  const n = [];
  for (; ++t < i.length; )
    (i[t].add === "after" ? e : n).push(i[t]);
  Y(e, 0, 0, n);
}
function kt(e, i) {
  const t = Number.parseInt(e, i);
  return t < 9 || t === 11 || t > 13 && t < 32 || t > 126 && t < 160 || t > 55295 && t < 57344 || t > 64975 && t < 65008 || (t & 65535) === 65535 || (t & 65535) === 65534 || t > 1114111 ? "�" : String.fromCodePoint(t);
}
function te(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const Q = fe(/[A-Za-z]/), Z = fe(/[\dA-Za-z]/), Yt = fe(/[#-'*+\--9=?A-Z^-~]/);
function Ee(e) {
  return e !== null && (e < 32 || e === 127);
}
const He = fe(/\d/), Gt = fe(/[\dA-Fa-f]/), Jt = fe(/[!-/:-@[-`{-~]/);
function I(e) {
  return e !== null && e < -2;
}
function H(e) {
  return e !== null && (e < 0 || e === 32);
}
function L(e) {
  return e === -2 || e === -1 || e === 32;
}
const Me = fe(new RegExp("\\p{P}|\\p{S}", "u")), pe = fe(/\s/);
function fe(e) {
  return i;
  function i(t) {
    return t !== null && t > -1 && e.test(String.fromCharCode(t));
  }
}
function M(e, i, t, n) {
  const c = n ? n - 1 : Number.POSITIVE_INFINITY;
  let r = 0;
  return o;
  function o(l) {
    return L(l) ? (e.enter(t), u(l)) : i(l);
  }
  function u(l) {
    return L(l) && r++ < c ? (e.consume(l), u) : (e.exit(t), i(l));
  }
}
const Xt = { tokenize: en };
function en(e) {
  const i = e.attempt(this.parser.constructs.contentInitial, n, c);
  let t;
  return i;
  function n(u) {
    if (u === null) {
      e.consume(u);
      return;
    }
    return e.enter("lineEnding"), e.consume(u), e.exit("lineEnding"), M(e, i, "linePrefix");
  }
  function c(u) {
    return e.enter("paragraph"), r(u);
  }
  function r(u) {
    const l = e.enter("chunkText", { contentType: "text", previous: t });
    return t && (t.next = l), t = l, o(u);
  }
  function o(u) {
    if (u === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(u);
      return;
    }
    return I(u) ? (e.consume(u), e.exit("chunkText"), r) : (e.consume(u), o);
  }
}
const tn = { tokenize: nn }, et = { tokenize: rn };
function nn(e) {
  const i = this, t = [];
  let n = 0, c, r, o;
  return u;
  function u(S) {
    if (n < t.length) {
      const E = t[n];
      return i.containerState = E[1], e.attempt(E[0].continuation, l, a)(S);
    }
    return a(S);
  }
  function l(S) {
    if (n++, i.containerState._closeFlow) {
      i.containerState._closeFlow = void 0, c && A();
      const E = i.events.length;
      let O = E, b;
      for (; O--; )
        if (i.events[O][0] === "exit" && i.events[O][1].type === "chunkFlow") {
          b = i.events[O][1].end;
          break;
        }
      y(n);
      let _ = E;
      for (; _ < i.events.length; )
        i.events[_][1].end = Object.assign({}, b), _++;
      return Y(i.events, O + 1, 0, i.events.slice(E)), i.events.length = _, a(S);
    }
    return u(S);
  }
  function a(S) {
    if (n === t.length) {
      if (!c)
        return p(S);
      if (c.currentConstruct && c.currentConstruct.concrete)
        return x(S);
      i.interrupt = !!(c.currentConstruct && !c._gfmTableDynamicInterruptHack);
    }
    return i.containerState = {}, e.check(et, m, s)(S);
  }
  function m(S) {
    return c && A(), y(n), p(S);
  }
  function s(S) {
    return i.parser.lazy[i.now().line] = n !== t.length, o = i.now().offset, x(S);
  }
  function p(S) {
    return i.containerState = {}, e.attempt(et, f, x)(S);
  }
  function f(S) {
    return n++, t.push([i.currentConstruct, i.containerState]), p(S);
  }
  function x(S) {
    if (S === null) {
      c && A(), y(0), e.consume(S);
      return;
    }
    return c = c || i.parser.flow(i.now()), e.enter("chunkFlow", { contentType: "flow", previous: r, _tokenizer: c }), T(S);
  }
  function T(S) {
    if (S === null) {
      C(e.exit("chunkFlow"), !0), y(0), e.consume(S);
      return;
    }
    return I(S) ? (e.consume(S), C(e.exit("chunkFlow")), n = 0, i.interrupt = void 0, u) : (e.consume(S), T);
  }
  function C(S, E) {
    const O = i.sliceStream(S);
    if (E && O.push(null), S.previous = r, r && (r.next = S), r = S, c.defineSkip(S.start), c.write(O), i.parser.lazy[S.start.line]) {
      let b = c.events.length;
      for (; b--; )
        if (c.events[b][1].start.offset < o && (!c.events[b][1].end || c.events[b][1].end.offset > o))
          return;
      const _ = i.events.length;
      let V = _, P, g;
      for (; V--; )
        if (i.events[V][0] === "exit" && i.events[V][1].type === "chunkFlow") {
          if (P) {
            g = i.events[V][1].end;
            break;
          }
          P = !0;
        }
      for (y(n), b = _; b < i.events.length; )
        i.events[b][1].end = Object.assign({}, g), b++;
      Y(i.events, V + 1, 0, i.events.slice(_)), i.events.length = b;
    }
  }
  function y(S) {
    let E = t.length;
    for (; E-- > S; ) {
      const O = t[E];
      i.containerState = O[1], O[0].exit.call(i, e);
    }
    t.length = S;
  }
  function A() {
    c.write([null]), r = void 0, c = void 0, i.containerState._closeFlow = void 0;
  }
}
function rn(e, i, t) {
  return M(e, e.attempt(this.parser.constructs.document, i, t), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function Le(e) {
  if (e === null || H(e) || pe(e))
    return 1;
  if (Me(e))
    return 2;
}
function _e(e, i, t) {
  const n = [];
  let c = -1;
  for (; ++c < e.length; ) {
    const r = e[c].resolveAll;
    r && !n.includes(r) && (i = r(i, t), n.push(r));
  }
  return i;
}
const qe = { name: "attention", tokenize: cn, resolveAll: on };
function on(e, i) {
  let t = -1, n, c, r, o, u, l, a, m;
  for (; ++t < e.length; )
    if (e[t][0] === "enter" && e[t][1].type === "attentionSequence" && e[t][1]._close) {
      for (n = t; n--; )
        if (e[n][0] === "exit" && e[n][1].type === "attentionSequence" && e[n][1]._open && i.sliceSerialize(e[n][1]).charCodeAt(0) === i.sliceSerialize(e[t][1]).charCodeAt(0)) {
          if ((e[n][1]._close || e[t][1]._open) && (e[t][1].end.offset - e[t][1].start.offset) % 3 && !((e[n][1].end.offset - e[n][1].start.offset + e[t][1].end.offset - e[t][1].start.offset) % 3))
            continue;
          l = e[n][1].end.offset - e[n][1].start.offset > 1 && e[t][1].end.offset - e[t][1].start.offset > 1 ? 2 : 1;
          const s = Object.assign({}, e[n][1].end), p = Object.assign({}, e[t][1].start);
          tt(s, -l), tt(p, l), o = { type: l > 1 ? "strongSequence" : "emphasisSequence", start: s, end: Object.assign({}, e[n][1].end) }, u = { type: l > 1 ? "strongSequence" : "emphasisSequence", start: Object.assign({}, e[t][1].start), end: p }, r = { type: l > 1 ? "strongText" : "emphasisText", start: Object.assign({}, e[n][1].end), end: Object.assign({}, e[t][1].start) }, c = { type: l > 1 ? "strong" : "emphasis", start: Object.assign({}, o.start), end: Object.assign({}, u.end) }, e[n][1].end = Object.assign({}, o.start), e[t][1].start = Object.assign({}, u.end), a = [], e[n][1].end.offset - e[n][1].start.offset && (a = G(a, [["enter", e[n][1], i], ["exit", e[n][1], i]])), a = G(a, [["enter", c, i], ["enter", o, i], ["exit", o, i], ["enter", r, i]]), a = G(a, _e(i.parser.constructs.insideSpan.null, e.slice(n + 1, t), i)), a = G(a, [["exit", r, i], ["enter", u, i], ["exit", u, i], ["exit", c, i]]), e[t][1].end.offset - e[t][1].start.offset ? (m = 2, a = G(a, [["enter", e[t][1], i], ["exit", e[t][1], i]])) : m = 0, Y(e, n - 1, t - n + 3, a), t = n + a.length - m - 2;
          break;
        }
    }
  for (t = -1; ++t < e.length; )
    e[t][1].type === "attentionSequence" && (e[t][1].type = "data");
  return e;
}
function cn(e, i) {
  const t = this.parser.constructs.attentionMarkers.null, n = this.previous, c = Le(n);
  let r;
  return o;
  function o(l) {
    return r = l, e.enter("attentionSequence"), u(l);
  }
  function u(l) {
    if (l === r)
      return e.consume(l), u;
    const a = e.exit("attentionSequence"), m = Le(l), s = !m || m === 2 && c || t.includes(l), p = !c || c === 2 && m || t.includes(n);
    return a._open = !!(r === 42 ? s : s && (c || !p)), a._close = !!(r === 42 ? p : p && (m || !s)), i(l);
  }
}
function tt(e, i) {
  e.column += i, e.offset += i, e._bufferIndex += i;
}
const un = { name: "autolink", tokenize: sn };
function sn(e, i, t) {
  let n = 0;
  return c;
  function c(f) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(f), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), r;
  }
  function r(f) {
    return Q(f) ? (e.consume(f), o) : a(f);
  }
  function o(f) {
    return f === 43 || f === 45 || f === 46 || Z(f) ? (n = 1, u(f)) : a(f);
  }
  function u(f) {
    return f === 58 ? (e.consume(f), n = 0, l) : (f === 43 || f === 45 || f === 46 || Z(f)) && n++ < 32 ? (e.consume(f), u) : (n = 0, a(f));
  }
  function l(f) {
    return f === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(f), e.exit("autolinkMarker"), e.exit("autolink"), i) : f === null || f === 32 || f === 60 || Ee(f) ? t(f) : (e.consume(f), l);
  }
  function a(f) {
    return f === 64 ? (e.consume(f), m) : Yt(f) ? (e.consume(f), a) : t(f);
  }
  function m(f) {
    return Z(f) ? s(f) : t(f);
  }
  function s(f) {
    return f === 46 ? (e.consume(f), n = 0, m) : f === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(f), e.exit("autolinkMarker"), e.exit("autolink"), i) : p(f);
  }
  function p(f) {
    if ((f === 45 || Z(f)) && n++ < 63) {
      const x = f === 45 ? p : s;
      return e.consume(f), x;
    }
    return t(f);
  }
}
const Ie = { tokenize: ln, partial: !0 };
function ln(e, i, t) {
  return n;
  function n(r) {
    return L(r) ? M(e, c, "linePrefix")(r) : c(r);
  }
  function c(r) {
    return r === null || I(r) ? i(r) : t(r);
  }
}
const xt = { name: "blockQuote", tokenize: an, continuation: { tokenize: fn }, exit: dn };
function an(e, i, t) {
  const n = this;
  return c;
  function c(o) {
    if (o === 62) {
      const u = n.containerState;
      return u.open || (e.enter("blockQuote", { _container: !0 }), u.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(o), e.exit("blockQuoteMarker"), r;
    }
    return t(o);
  }
  function r(o) {
    return L(o) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(o), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), i) : (e.exit("blockQuotePrefix"), i(o));
  }
}
function fn(e, i, t) {
  const n = this;
  return c;
  function c(o) {
    return L(o) ? M(e, r, "linePrefix", n.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(o) : r(o);
  }
  function r(o) {
    return e.attempt(xt, i, t)(o);
  }
}
function dn(e) {
  e.exit("blockQuote");
}
const bt = { name: "characterEscape", tokenize: hn };
function hn(e, i, t) {
  return n;
  function n(r) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(r), e.exit("escapeMarker"), c;
  }
  function c(r) {
    return Jt(r) ? (e.enter("characterEscapeValue"), e.consume(r), e.exit("characterEscapeValue"), e.exit("characterEscape"), i) : t(r);
  }
}
const yt = { name: "characterReference", tokenize: mn };
function mn(e, i, t) {
  const n = this;
  let c = 0, r, o;
  return u;
  function u(s) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(s), e.exit("characterReferenceMarker"), l;
  }
  function l(s) {
    return s === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(s), e.exit("characterReferenceMarkerNumeric"), a) : (e.enter("characterReferenceValue"), r = 31, o = Z, m(s));
  }
  function a(s) {
    return s === 88 || s === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(s), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), r = 6, o = Gt, m) : (e.enter("characterReferenceValue"), r = 7, o = He, m(s));
  }
  function m(s) {
    if (s === 59 && c) {
      const p = e.exit("characterReferenceValue");
      return o === Z && !Be(n.sliceSerialize(p)) ? t(s) : (e.enter("characterReferenceMarker"), e.consume(s), e.exit("characterReferenceMarker"), e.exit("characterReference"), i);
    }
    return o(s) && c++ < r ? (e.consume(s), m) : t(s);
  }
}
const nt = { tokenize: gn, partial: !0 }, it = { name: "codeFenced", tokenize: pn, concrete: !0 };
function pn(e, i, t) {
  const n = this, c = { tokenize: O, partial: !0 };
  let r = 0, o = 0, u;
  return l;
  function l(b) {
    return a(b);
  }
  function a(b) {
    const _ = n.events[n.events.length - 1];
    return r = _ && _[1].type === "linePrefix" ? _[2].sliceSerialize(_[1], !0).length : 0, u = b, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), m(b);
  }
  function m(b) {
    return b === u ? (o++, e.consume(b), m) : o < 3 ? t(b) : (e.exit("codeFencedFenceSequence"), L(b) ? M(e, s, "whitespace")(b) : s(b));
  }
  function s(b) {
    return b === null || I(b) ? (e.exit("codeFencedFence"), n.interrupt ? i(b) : e.check(nt, T, E)(b)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", { contentType: "string" }), p(b));
  }
  function p(b) {
    return b === null || I(b) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), s(b)) : L(b) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), M(e, f, "whitespace")(b)) : b === 96 && b === u ? t(b) : (e.consume(b), p);
  }
  function f(b) {
    return b === null || I(b) ? s(b) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", { contentType: "string" }), x(b));
  }
  function x(b) {
    return b === null || I(b) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), s(b)) : b === 96 && b === u ? t(b) : (e.consume(b), x);
  }
  function T(b) {
    return e.attempt(c, E, C)(b);
  }
  function C(b) {
    return e.enter("lineEnding"), e.consume(b), e.exit("lineEnding"), y;
  }
  function y(b) {
    return r > 0 && L(b) ? M(e, A, "linePrefix", r + 1)(b) : A(b);
  }
  function A(b) {
    return b === null || I(b) ? e.check(nt, T, E)(b) : (e.enter("codeFlowValue"), S(b));
  }
  function S(b) {
    return b === null || I(b) ? (e.exit("codeFlowValue"), A(b)) : (e.consume(b), S);
  }
  function E(b) {
    return e.exit("codeFenced"), i(b);
  }
  function O(b, _, V) {
    let P = 0;
    return g;
    function g(D) {
      return b.enter("lineEnding"), b.consume(D), b.exit("lineEnding"), w;
    }
    function w(D) {
      return b.enter("codeFencedFence"), L(D) ? M(b, F, "linePrefix", n.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(D) : F(D);
    }
    function F(D) {
      return D === u ? (b.enter("codeFencedFenceSequence"), j(D)) : V(D);
    }
    function j(D) {
      return D === u ? (P++, b.consume(D), j) : P >= o ? (b.exit("codeFencedFenceSequence"), L(D) ? M(b, B, "whitespace")(D) : B(D)) : V(D);
    }
    function B(D) {
      return D === null || I(D) ? (b.exit("codeFencedFence"), _(D)) : V(D);
    }
  }
}
function gn(e, i, t) {
  const n = this;
  return c;
  function c(o) {
    return o === null ? t(o) : (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), r);
  }
  function r(o) {
    return n.parser.lazy[n.now().line] ? t(o) : i(o);
  }
}
const Oe = { name: "codeIndented", tokenize: xn }, kn = { tokenize: bn, partial: !0 };
function xn(e, i, t) {
  const n = this;
  return c;
  function c(a) {
    return e.enter("codeIndented"), M(e, r, "linePrefix", 5)(a);
  }
  function r(a) {
    const m = n.events[n.events.length - 1];
    return m && m[1].type === "linePrefix" && m[2].sliceSerialize(m[1], !0).length >= 4 ? o(a) : t(a);
  }
  function o(a) {
    return a === null ? l(a) : I(a) ? e.attempt(kn, o, l)(a) : (e.enter("codeFlowValue"), u(a));
  }
  function u(a) {
    return a === null || I(a) ? (e.exit("codeFlowValue"), o(a)) : (e.consume(a), u);
  }
  function l(a) {
    return e.exit("codeIndented"), i(a);
  }
}
function bn(e, i, t) {
  const n = this;
  return c;
  function c(o) {
    return n.parser.lazy[n.now().line] ? t(o) : I(o) ? (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), c) : M(e, r, "linePrefix", 5)(o);
  }
  function r(o) {
    const u = n.events[n.events.length - 1];
    return u && u[1].type === "linePrefix" && u[2].sliceSerialize(u[1], !0).length >= 4 ? i(o) : I(o) ? c(o) : t(o);
  }
}
const yn = { name: "codeText", tokenize: wn, resolve: vn, previous: Sn };
function vn(e) {
  let i = e.length - 4, t = 3, n, c;
  if ((e[t][1].type === "lineEnding" || e[t][1].type === "space") && (e[i][1].type === "lineEnding" || e[i][1].type === "space")) {
    for (n = t; ++n < i; )
      if (e[n][1].type === "codeTextData") {
        e[t][1].type = "codeTextPadding", e[i][1].type = "codeTextPadding", t += 2, i -= 2;
        break;
      }
  }
  for (n = t - 1, i++; ++n <= i; )
    c === void 0 ? n !== i && e[n][1].type !== "lineEnding" && (c = n) : (n === i || e[n][1].type === "lineEnding") && (e[c][1].type = "codeTextData", n !== c + 2 && (e[c][1].end = e[n - 1][1].end, e.splice(c + 2, n - c - 2), i -= n - c - 2, n = c + 2), c = void 0);
  return e;
}
function Sn(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function wn(e, i, t) {
  let n = 0, c, r;
  return o;
  function o(s) {
    return e.enter("codeText"), e.enter("codeTextSequence"), u(s);
  }
  function u(s) {
    return s === 96 ? (e.consume(s), n++, u) : (e.exit("codeTextSequence"), l(s));
  }
  function l(s) {
    return s === null ? t(s) : s === 32 ? (e.enter("space"), e.consume(s), e.exit("space"), l) : s === 96 ? (r = e.enter("codeTextSequence"), c = 0, m(s)) : I(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), l) : (e.enter("codeTextData"), a(s));
  }
  function a(s) {
    return s === null || s === 32 || s === 96 || I(s) ? (e.exit("codeTextData"), l(s)) : (e.consume(s), a);
  }
  function m(s) {
    return s === 96 ? (e.consume(s), c++, m) : c === n ? (e.exit("codeTextSequence"), e.exit("codeText"), i(s)) : (r.type = "codeTextData", a(s));
  }
}
function vt(e) {
  const i = {};
  let t = -1, n, c, r, o, u, l, a;
  for (; ++t < e.length; ) {
    for (; t in i; )
      t = i[t];
    if (n = e[t], t && n[1].type === "chunkFlow" && e[t - 1][1].type === "listItemPrefix" && (l = n[1]._tokenizer.events, r = 0, r < l.length && l[r][1].type === "lineEndingBlank" && (r += 2), r < l.length && l[r][1].type === "content"))
      for (; ++r < l.length && l[r][1].type !== "content"; )
        l[r][1].type === "chunkText" && (l[r][1]._isInFirstContentOfListItem = !0, r++);
    if (n[0] === "enter")
      n[1].contentType && (Object.assign(i, Fn(e, t)), t = i[t], a = !0);
    else if (n[1]._container) {
      for (r = t, c = void 0; r-- && (o = e[r], o[1].type === "lineEnding" || o[1].type === "lineEndingBlank"); )
        o[0] === "enter" && (c && (e[c][1].type = "lineEndingBlank"), o[1].type = "lineEnding", c = r);
      c && (n[1].end = Object.assign({}, e[c][1].start), u = e.slice(c, t), u.unshift(n), Y(e, c, t - c + 1, u));
    }
  }
  return !a;
}
function Fn(e, i) {
  const t = e[i][1], n = e[i][2];
  let c = i - 1;
  const r = [], o = t._tokenizer || n.parser[t.contentType](t.start), u = o.events, l = [], a = {};
  let m, s, p = -1, f = t, x = 0, T = 0;
  const C = [T];
  for (; f; ) {
    for (; e[++c][1] !== f; )
      ;
    r.push(c), f._tokenizer || (m = n.sliceStream(f), f.next || m.push(null), s && o.defineSkip(f.start), f._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = !0), o.write(m), f._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = void 0)), s = f, f = f.next;
  }
  for (f = t; ++p < u.length; )
    u[p][0] === "exit" && u[p - 1][0] === "enter" && u[p][1].type === u[p - 1][1].type && u[p][1].start.line !== u[p][1].end.line && (T = p + 1, C.push(T), f._tokenizer = void 0, f.previous = void 0, f = f.next);
  for (o.events = [], f ? (f._tokenizer = void 0, f.previous = void 0) : C.pop(), p = C.length; p--; ) {
    const y = u.slice(C[p], C[p + 1]), A = r.pop();
    l.unshift([A, A + y.length - 1]), Y(e, A, 2, y);
  }
  for (p = -1; ++p < l.length; )
    a[x + l[p][0]] = x + l[p][1], x += l[p][1] - l[p][0] - 1;
  return a;
}
const In = { tokenize: Cn, resolve: zn }, Tn = { tokenize: En, partial: !0 };
function zn(e) {
  return vt(e), e;
}
function Cn(e, i) {
  let t;
  return n;
  function n(u) {
    return e.enter("content"), t = e.enter("chunkContent", { contentType: "content" }), c(u);
  }
  function c(u) {
    return u === null ? r(u) : I(u) ? e.check(Tn, o, r)(u) : (e.consume(u), c);
  }
  function r(u) {
    return e.exit("chunkContent"), e.exit("content"), i(u);
  }
  function o(u) {
    return e.consume(u), e.exit("chunkContent"), t.next = e.enter("chunkContent", { contentType: "content", previous: t }), t = t.next, c;
  }
}
function En(e, i, t) {
  const n = this;
  return c;
  function c(o) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), M(e, r, "linePrefix");
  }
  function r(o) {
    if (o === null || I(o))
      return t(o);
    const u = n.events[n.events.length - 1];
    return !n.parser.constructs.disable.null.includes("codeIndented") && u && u[1].type === "linePrefix" && u[2].sliceSerialize(u[1], !0).length >= 4 ? i(o) : e.interrupt(n.parser.constructs.flow, t, i)(o);
  }
}
function St(e, i, t, n, c, r, o, u, l) {
  const a = l || Number.POSITIVE_INFINITY;
  let m = 0;
  return s;
  function s(y) {
    return y === 60 ? (e.enter(n), e.enter(c), e.enter(r), e.consume(y), e.exit(r), p) : y === null || y === 32 || y === 41 || Ee(y) ? t(y) : (e.enter(n), e.enter(o), e.enter(u), e.enter("chunkString", { contentType: "string" }), T(y));
  }
  function p(y) {
    return y === 62 ? (e.enter(r), e.consume(y), e.exit(r), e.exit(c), e.exit(n), i) : (e.enter(u), e.enter("chunkString", { contentType: "string" }), f(y));
  }
  function f(y) {
    return y === 62 ? (e.exit("chunkString"), e.exit(u), p(y)) : y === null || y === 60 || I(y) ? t(y) : (e.consume(y), y === 92 ? x : f);
  }
  function x(y) {
    return y === 60 || y === 62 || y === 92 ? (e.consume(y), f) : f(y);
  }
  function T(y) {
    return !m && (y === null || y === 41 || H(y)) ? (e.exit("chunkString"), e.exit(u), e.exit(o), e.exit(n), i(y)) : m < a && y === 40 ? (e.consume(y), m++, T) : y === 41 ? (e.consume(y), m--, T) : y === null || y === 32 || y === 40 || Ee(y) ? t(y) : (e.consume(y), y === 92 ? C : T);
  }
  function C(y) {
    return y === 40 || y === 41 || y === 92 ? (e.consume(y), T) : T(y);
  }
}
function wt(e, i, t, n, c, r) {
  const o = this;
  let u = 0, l;
  return a;
  function a(f) {
    return e.enter(n), e.enter(c), e.consume(f), e.exit(c), e.enter(r), m;
  }
  function m(f) {
    return u > 999 || f === null || f === 91 || f === 93 && !l || f === 94 && !u && "_hiddenFootnoteSupport" in o.parser.constructs ? t(f) : f === 93 ? (e.exit(r), e.enter(c), e.consume(f), e.exit(c), e.exit(n), i) : I(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), m) : (e.enter("chunkString", { contentType: "string" }), s(f));
  }
  function s(f) {
    return f === null || f === 91 || f === 93 || I(f) || u++ > 999 ? (e.exit("chunkString"), m(f)) : (e.consume(f), l || (l = !L(f)), f === 92 ? p : s);
  }
  function p(f) {
    return f === 91 || f === 92 || f === 93 ? (e.consume(f), u++, s) : s(f);
  }
}
function Ft(e, i, t, n, c, r) {
  let o;
  return u;
  function u(p) {
    return p === 34 || p === 39 || p === 40 ? (e.enter(n), e.enter(c), e.consume(p), e.exit(c), o = p === 40 ? 41 : p, l) : t(p);
  }
  function l(p) {
    return p === o ? (e.enter(c), e.consume(p), e.exit(c), e.exit(n), i) : (e.enter(r), a(p));
  }
  function a(p) {
    return p === o ? (e.exit(r), l(o)) : p === null ? t(p) : I(p) ? (e.enter("lineEnding"), e.consume(p), e.exit("lineEnding"), M(e, a, "linePrefix")) : (e.enter("chunkString", { contentType: "string" }), m(p));
  }
  function m(p) {
    return p === o || p === null || I(p) ? (e.exit("chunkString"), a(p)) : (e.consume(p), p === 92 ? s : m);
  }
  function s(p) {
    return p === o || p === 92 ? (e.consume(p), m) : m(p);
  }
}
function Fe(e, i) {
  let t;
  return n;
  function n(c) {
    return I(c) ? (e.enter("lineEnding"), e.consume(c), e.exit("lineEnding"), t = !0, n) : L(c) ? M(e, n, t ? "linePrefix" : "lineSuffix")(c) : i(c);
  }
}
const Ln = { name: "definition", tokenize: _n }, Mn = { tokenize: Dn, partial: !0 };
function _n(e, i, t) {
  const n = this;
  let c;
  return r;
  function r(f) {
    return e.enter("definition"), o(f);
  }
  function o(f) {
    return wt.call(n, e, u, t, "definitionLabel", "definitionLabelMarker", "definitionLabelString")(f);
  }
  function u(f) {
    return c = te(n.sliceSerialize(n.events[n.events.length - 1][1]).slice(1, -1)), f === 58 ? (e.enter("definitionMarker"), e.consume(f), e.exit("definitionMarker"), l) : t(f);
  }
  function l(f) {
    return H(f) ? Fe(e, a)(f) : a(f);
  }
  function a(f) {
    return St(e, m, t, "definitionDestination", "definitionDestinationLiteral", "definitionDestinationLiteralMarker", "definitionDestinationRaw", "definitionDestinationString")(f);
  }
  function m(f) {
    return e.attempt(Mn, s, s)(f);
  }
  function s(f) {
    return L(f) ? M(e, p, "whitespace")(f) : p(f);
  }
  function p(f) {
    return f === null || I(f) ? (e.exit("definition"), n.parser.defined.push(c), i(f)) : t(f);
  }
}
function Dn(e, i, t) {
  return n;
  function n(u) {
    return H(u) ? Fe(e, c)(u) : t(u);
  }
  function c(u) {
    return Ft(e, r, t, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(u);
  }
  function r(u) {
    return L(u) ? M(e, o, "whitespace")(u) : o(u);
  }
  function o(u) {
    return u === null || I(u) ? i(u) : t(u);
  }
}
const An = { name: "hardBreakEscape", tokenize: On };
function On(e, i, t) {
  return n;
  function n(r) {
    return e.enter("hardBreakEscape"), e.consume(r), c;
  }
  function c(r) {
    return I(r) ? (e.exit("hardBreakEscape"), i(r)) : t(r);
  }
}
const Pn = { name: "headingAtx", tokenize: Rn, resolve: jn };
function jn(e, i) {
  let t = e.length - 2, n = 3, c, r;
  return e[n][1].type === "whitespace" && (n += 2), t - 2 > n && e[t][1].type === "whitespace" && (t -= 2), e[t][1].type === "atxHeadingSequence" && (n === t - 1 || t - 4 > n && e[t - 2][1].type === "whitespace") && (t -= n + 1 === t ? 2 : 4), t > n && (c = { type: "atxHeadingText", start: e[n][1].start, end: e[t][1].end }, r = { type: "chunkText", start: e[n][1].start, end: e[t][1].end, contentType: "text" }, Y(e, n, t - n + 1, [["enter", c, i], ["enter", r, i], ["exit", r, i], ["exit", c, i]])), e;
}
function Rn(e, i, t) {
  let n = 0;
  return c;
  function c(m) {
    return e.enter("atxHeading"), r(m);
  }
  function r(m) {
    return e.enter("atxHeadingSequence"), o(m);
  }
  function o(m) {
    return m === 35 && n++ < 6 ? (e.consume(m), o) : m === null || H(m) ? (e.exit("atxHeadingSequence"), u(m)) : t(m);
  }
  function u(m) {
    return m === 35 ? (e.enter("atxHeadingSequence"), l(m)) : m === null || I(m) ? (e.exit("atxHeading"), i(m)) : L(m) ? M(e, u, "whitespace")(m) : (e.enter("atxHeadingText"), a(m));
  }
  function l(m) {
    return m === 35 ? (e.consume(m), l) : (e.exit("atxHeadingSequence"), u(m));
  }
  function a(m) {
    return m === null || m === 35 || H(m) ? (e.exit("atxHeadingText"), u(m)) : (e.consume(m), a);
  }
}
const Hn = ["address", "article", "aside", "base", "basefont", "blockquote", "body", "caption", "center", "col", "colgroup", "dd", "details", "dialog", "dir", "div", "dl", "dt", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hr", "html", "iframe", "legend", "li", "link", "main", "menu", "menuitem", "nav", "noframes", "ol", "optgroup", "option", "p", "param", "search", "section", "summary", "table", "tbody", "td", "tfoot", "th", "thead", "title", "tr", "track", "ul"], rt = ["pre", "script", "style", "textarea"], qn = { name: "htmlFlow", tokenize: Nn, resolveTo: Wn, concrete: !0 }, Vn = { tokenize: Qn, partial: !0 }, Bn = { tokenize: Un, partial: !0 };
function Wn(e) {
  let i = e.length;
  for (; i-- && !(e[i][0] === "enter" && e[i][1].type === "htmlFlow"); )
    ;
  return i > 1 && e[i - 2][1].type === "linePrefix" && (e[i][1].start = e[i - 2][1].start, e[i + 1][1].start = e[i - 2][1].start, e.splice(i - 2, 2)), e;
}
function Nn(e, i, t) {
  const n = this;
  let c, r, o, u, l;
  return a;
  function a(h) {
    return m(h);
  }
  function m(h) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(h), s;
  }
  function s(h) {
    return h === 33 ? (e.consume(h), p) : h === 47 ? (e.consume(h), r = !0, T) : h === 63 ? (e.consume(h), c = 3, n.interrupt ? i : d) : Q(h) ? (e.consume(h), o = String.fromCharCode(h), C) : t(h);
  }
  function p(h) {
    return h === 45 ? (e.consume(h), c = 2, f) : h === 91 ? (e.consume(h), c = 5, u = 0, x) : Q(h) ? (e.consume(h), c = 4, n.interrupt ? i : d) : t(h);
  }
  function f(h) {
    return h === 45 ? (e.consume(h), n.interrupt ? i : d) : t(h);
  }
  function x(h) {
    const ee = "CDATA[";
    return h === ee.charCodeAt(u++) ? (e.consume(h), u === ee.length ? n.interrupt ? i : F : x) : t(h);
  }
  function T(h) {
    return Q(h) ? (e.consume(h), o = String.fromCharCode(h), C) : t(h);
  }
  function C(h) {
    if (h === null || h === 47 || h === 62 || H(h)) {
      const ee = h === 47, de = o.toLowerCase();
      return !ee && !r && rt.includes(de) ? (c = 1, n.interrupt ? i(h) : F(h)) : Hn.includes(o.toLowerCase()) ? (c = 6, ee ? (e.consume(h), y) : n.interrupt ? i(h) : F(h)) : (c = 7, n.interrupt && !n.parser.lazy[n.now().line] ? t(h) : r ? A(h) : S(h));
    }
    return h === 45 || Z(h) ? (e.consume(h), o += String.fromCharCode(h), C) : t(h);
  }
  function y(h) {
    return h === 62 ? (e.consume(h), n.interrupt ? i : F) : t(h);
  }
  function A(h) {
    return L(h) ? (e.consume(h), A) : g(h);
  }
  function S(h) {
    return h === 47 ? (e.consume(h), g) : h === 58 || h === 95 || Q(h) ? (e.consume(h), E) : L(h) ? (e.consume(h), S) : g(h);
  }
  function E(h) {
    return h === 45 || h === 46 || h === 58 || h === 95 || Z(h) ? (e.consume(h), E) : O(h);
  }
  function O(h) {
    return h === 61 ? (e.consume(h), b) : L(h) ? (e.consume(h), O) : S(h);
  }
  function b(h) {
    return h === null || h === 60 || h === 61 || h === 62 || h === 96 ? t(h) : h === 34 || h === 39 ? (e.consume(h), l = h, _) : L(h) ? (e.consume(h), b) : V(h);
  }
  function _(h) {
    return h === l ? (e.consume(h), l = null, P) : h === null || I(h) ? t(h) : (e.consume(h), _);
  }
  function V(h) {
    return h === null || h === 34 || h === 39 || h === 47 || h === 60 || h === 61 || h === 62 || h === 96 || H(h) ? O(h) : (e.consume(h), V);
  }
  function P(h) {
    return h === 47 || h === 62 || L(h) ? S(h) : t(h);
  }
  function g(h) {
    return h === 62 ? (e.consume(h), w) : t(h);
  }
  function w(h) {
    return h === null || I(h) ? F(h) : L(h) ? (e.consume(h), w) : t(h);
  }
  function F(h) {
    return h === 45 && c === 2 ? (e.consume(h), U) : h === 60 && c === 1 ? (e.consume(h), W) : h === 62 && c === 4 ? (e.consume(h), X) : h === 63 && c === 3 ? (e.consume(h), d) : h === 93 && c === 5 ? (e.consume(h), re) : I(h) && (c === 6 || c === 7) ? (e.exit("htmlFlowData"), e.check(Vn, oe, j)(h)) : h === null || I(h) ? (e.exit("htmlFlowData"), j(h)) : (e.consume(h), F);
  }
  function j(h) {
    return e.check(Bn, B, oe)(h);
  }
  function B(h) {
    return e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), D;
  }
  function D(h) {
    return h === null || I(h) ? j(h) : (e.enter("htmlFlowData"), F(h));
  }
  function U(h) {
    return h === 45 ? (e.consume(h), d) : F(h);
  }
  function W(h) {
    return h === 47 ? (e.consume(h), o = "", J) : F(h);
  }
  function J(h) {
    if (h === 62) {
      const ee = o.toLowerCase();
      return rt.includes(ee) ? (e.consume(h), X) : F(h);
    }
    return Q(h) && o.length < 8 ? (e.consume(h), o += String.fromCharCode(h), J) : F(h);
  }
  function re(h) {
    return h === 93 ? (e.consume(h), d) : F(h);
  }
  function d(h) {
    return h === 62 ? (e.consume(h), X) : h === 45 && c === 2 ? (e.consume(h), d) : F(h);
  }
  function X(h) {
    return h === null || I(h) ? (e.exit("htmlFlowData"), oe(h)) : (e.consume(h), X);
  }
  function oe(h) {
    return e.exit("htmlFlow"), i(h);
  }
}
function Un(e, i, t) {
  const n = this;
  return c;
  function c(o) {
    return I(o) ? (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), r) : t(o);
  }
  function r(o) {
    return n.parser.lazy[n.now().line] ? t(o) : i(o);
  }
}
function Qn(e, i, t) {
  return n;
  function n(c) {
    return e.enter("lineEnding"), e.consume(c), e.exit("lineEnding"), e.attempt(Ie, i, t);
  }
}
const $n = { name: "htmlText", tokenize: Zn };
function Zn(e, i, t) {
  const n = this;
  let c, r, o;
  return u;
  function u(d) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(d), l;
  }
  function l(d) {
    return d === 33 ? (e.consume(d), a) : d === 47 ? (e.consume(d), O) : d === 63 ? (e.consume(d), S) : Q(d) ? (e.consume(d), V) : t(d);
  }
  function a(d) {
    return d === 45 ? (e.consume(d), m) : d === 91 ? (e.consume(d), r = 0, x) : Q(d) ? (e.consume(d), A) : t(d);
  }
  function m(d) {
    return d === 45 ? (e.consume(d), f) : t(d);
  }
  function s(d) {
    return d === null ? t(d) : d === 45 ? (e.consume(d), p) : I(d) ? (o = s, W(d)) : (e.consume(d), s);
  }
  function p(d) {
    return d === 45 ? (e.consume(d), f) : s(d);
  }
  function f(d) {
    return d === 62 ? U(d) : d === 45 ? p(d) : s(d);
  }
  function x(d) {
    const X = "CDATA[";
    return d === X.charCodeAt(r++) ? (e.consume(d), r === X.length ? T : x) : t(d);
  }
  function T(d) {
    return d === null ? t(d) : d === 93 ? (e.consume(d), C) : I(d) ? (o = T, W(d)) : (e.consume(d), T);
  }
  function C(d) {
    return d === 93 ? (e.consume(d), y) : T(d);
  }
  function y(d) {
    return d === 62 ? U(d) : d === 93 ? (e.consume(d), y) : T(d);
  }
  function A(d) {
    return d === null || d === 62 ? U(d) : I(d) ? (o = A, W(d)) : (e.consume(d), A);
  }
  function S(d) {
    return d === null ? t(d) : d === 63 ? (e.consume(d), E) : I(d) ? (o = S, W(d)) : (e.consume(d), S);
  }
  function E(d) {
    return d === 62 ? U(d) : S(d);
  }
  function O(d) {
    return Q(d) ? (e.consume(d), b) : t(d);
  }
  function b(d) {
    return d === 45 || Z(d) ? (e.consume(d), b) : _(d);
  }
  function _(d) {
    return I(d) ? (o = _, W(d)) : L(d) ? (e.consume(d), _) : U(d);
  }
  function V(d) {
    return d === 45 || Z(d) ? (e.consume(d), V) : d === 47 || d === 62 || H(d) ? P(d) : t(d);
  }
  function P(d) {
    return d === 47 ? (e.consume(d), U) : d === 58 || d === 95 || Q(d) ? (e.consume(d), g) : I(d) ? (o = P, W(d)) : L(d) ? (e.consume(d), P) : U(d);
  }
  function g(d) {
    return d === 45 || d === 46 || d === 58 || d === 95 || Z(d) ? (e.consume(d), g) : w(d);
  }
  function w(d) {
    return d === 61 ? (e.consume(d), F) : I(d) ? (o = w, W(d)) : L(d) ? (e.consume(d), w) : P(d);
  }
  function F(d) {
    return d === null || d === 60 || d === 61 || d === 62 || d === 96 ? t(d) : d === 34 || d === 39 ? (e.consume(d), c = d, j) : I(d) ? (o = F, W(d)) : L(d) ? (e.consume(d), F) : (e.consume(d), B);
  }
  function j(d) {
    return d === c ? (e.consume(d), c = void 0, D) : d === null ? t(d) : I(d) ? (o = j, W(d)) : (e.consume(d), j);
  }
  function B(d) {
    return d === null || d === 34 || d === 39 || d === 60 || d === 61 || d === 96 ? t(d) : d === 47 || d === 62 || H(d) ? P(d) : (e.consume(d), B);
  }
  function D(d) {
    return d === 47 || d === 62 || H(d) ? P(d) : t(d);
  }
  function U(d) {
    return d === 62 ? (e.consume(d), e.exit("htmlTextData"), e.exit("htmlText"), i) : t(d);
  }
  function W(d) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(d), e.exit("lineEnding"), J;
  }
  function J(d) {
    return L(d) ? M(e, re, "linePrefix", n.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(d) : re(d);
  }
  function re(d) {
    return e.enter("htmlTextData"), o(d);
  }
}
const We = { name: "labelEnd", tokenize: ei, resolveTo: Xn, resolveAll: Jn }, Kn = { tokenize: ti }, Yn = { tokenize: ni }, Gn = { tokenize: ii };
function Jn(e) {
  let i = -1;
  for (; ++i < e.length; ) {
    const t = e[i][1];
    (t.type === "labelImage" || t.type === "labelLink" || t.type === "labelEnd") && (e.splice(i + 1, t.type === "labelImage" ? 4 : 2), t.type = "data", i++);
  }
  return e;
}
function Xn(e, i) {
  let t = e.length, n = 0, c, r, o, u;
  for (; t--; )
    if (c = e[t][1], r) {
      if (c.type === "link" || c.type === "labelLink" && c._inactive)
        break;
      e[t][0] === "enter" && c.type === "labelLink" && (c._inactive = !0);
    } else if (o) {
      if (e[t][0] === "enter" && (c.type === "labelImage" || c.type === "labelLink") && !c._balanced && (r = t, c.type !== "labelLink")) {
        n = 2;
        break;
      }
    } else
      c.type === "labelEnd" && (o = t);
  const l = { type: e[r][1].type === "labelLink" ? "link" : "image", start: Object.assign({}, e[r][1].start), end: Object.assign({}, e[e.length - 1][1].end) }, a = { type: "label", start: Object.assign({}, e[r][1].start), end: Object.assign({}, e[o][1].end) }, m = { type: "labelText", start: Object.assign({}, e[r + n + 2][1].end), end: Object.assign({}, e[o - 2][1].start) };
  return u = [["enter", l, i], ["enter", a, i]], u = G(u, e.slice(r + 1, r + n + 3)), u = G(u, [["enter", m, i]]), u = G(u, _e(i.parser.constructs.insideSpan.null, e.slice(r + n + 4, o - 3), i)), u = G(u, [["exit", m, i], e[o - 2], e[o - 1], ["exit", a, i]]), u = G(u, e.slice(o + 1)), u = G(u, [["exit", l, i]]), Y(e, r, e.length, u), e;
}
function ei(e, i, t) {
  const n = this;
  let c = n.events.length, r, o;
  for (; c--; )
    if ((n.events[c][1].type === "labelImage" || n.events[c][1].type === "labelLink") && !n.events[c][1]._balanced) {
      r = n.events[c][1];
      break;
    }
  return u;
  function u(p) {
    return r ? r._inactive ? s(p) : (o = n.parser.defined.includes(te(n.sliceSerialize({ start: r.end, end: n.now() }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(p), e.exit("labelMarker"), e.exit("labelEnd"), l) : t(p);
  }
  function l(p) {
    return p === 40 ? e.attempt(Kn, m, o ? m : s)(p) : p === 91 ? e.attempt(Yn, m, o ? a : s)(p) : o ? m(p) : s(p);
  }
  function a(p) {
    return e.attempt(Gn, m, s)(p);
  }
  function m(p) {
    return i(p);
  }
  function s(p) {
    return r._balanced = !0, t(p);
  }
}
function ti(e, i, t) {
  return n;
  function n(s) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(s), e.exit("resourceMarker"), c;
  }
  function c(s) {
    return H(s) ? Fe(e, r)(s) : r(s);
  }
  function r(s) {
    return s === 41 ? m(s) : St(e, o, u, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(s);
  }
  function o(s) {
    return H(s) ? Fe(e, l)(s) : m(s);
  }
  function u(s) {
    return t(s);
  }
  function l(s) {
    return s === 34 || s === 39 || s === 40 ? Ft(e, a, t, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(s) : m(s);
  }
  function a(s) {
    return H(s) ? Fe(e, m)(s) : m(s);
  }
  function m(s) {
    return s === 41 ? (e.enter("resourceMarker"), e.consume(s), e.exit("resourceMarker"), e.exit("resource"), i) : t(s);
  }
}
function ni(e, i, t) {
  const n = this;
  return c;
  function c(u) {
    return wt.call(n, e, r, o, "reference", "referenceMarker", "referenceString")(u);
  }
  function r(u) {
    return n.parser.defined.includes(te(n.sliceSerialize(n.events[n.events.length - 1][1]).slice(1, -1))) ? i(u) : t(u);
  }
  function o(u) {
    return t(u);
  }
}
function ii(e, i, t) {
  return n;
  function n(r) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(r), e.exit("referenceMarker"), c;
  }
  function c(r) {
    return r === 93 ? (e.enter("referenceMarker"), e.consume(r), e.exit("referenceMarker"), e.exit("reference"), i) : t(r);
  }
}
const ri = { name: "labelStartImage", tokenize: oi, resolveAll: We.resolveAll };
function oi(e, i, t) {
  const n = this;
  return c;
  function c(u) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(u), e.exit("labelImageMarker"), r;
  }
  function r(u) {
    return u === 91 ? (e.enter("labelMarker"), e.consume(u), e.exit("labelMarker"), e.exit("labelImage"), o) : t(u);
  }
  function o(u) {
    return u === 94 && "_hiddenFootnoteSupport" in n.parser.constructs ? t(u) : i(u);
  }
}
const ci = { name: "labelStartLink", tokenize: ui, resolveAll: We.resolveAll };
function ui(e, i, t) {
  const n = this;
  return c;
  function c(o) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(o), e.exit("labelMarker"), e.exit("labelLink"), r;
  }
  function r(o) {
    return o === 94 && "_hiddenFootnoteSupport" in n.parser.constructs ? t(o) : i(o);
  }
}
const Pe = { name: "lineEnding", tokenize: si };
function si(e, i) {
  return t;
  function t(n) {
    return e.enter("lineEnding"), e.consume(n), e.exit("lineEnding"), M(e, i, "linePrefix");
  }
}
const Ce = { name: "thematicBreak", tokenize: li };
function li(e, i, t) {
  let n = 0, c;
  return r;
  function r(a) {
    return e.enter("thematicBreak"), o(a);
  }
  function o(a) {
    return c = a, u(a);
  }
  function u(a) {
    return a === c ? (e.enter("thematicBreakSequence"), l(a)) : n >= 3 && (a === null || I(a)) ? (e.exit("thematicBreak"), i(a)) : t(a);
  }
  function l(a) {
    return a === c ? (e.consume(a), n++, l) : (e.exit("thematicBreakSequence"), L(a) ? M(e, u, "whitespace")(a) : u(a));
  }
}
const $ = { name: "list", tokenize: di, continuation: { tokenize: hi }, exit: pi }, ai = { tokenize: gi, partial: !0 }, fi = { tokenize: mi, partial: !0 };
function di(e, i, t) {
  const n = this, c = n.events[n.events.length - 1];
  let r = c && c[1].type === "linePrefix" ? c[2].sliceSerialize(c[1], !0).length : 0, o = 0;
  return u;
  function u(f) {
    const x = n.containerState.type || (f === 42 || f === 43 || f === 45 ? "listUnordered" : "listOrdered");
    if (x === "listUnordered" ? !n.containerState.marker || f === n.containerState.marker : He(f)) {
      if (n.containerState.type || (n.containerState.type = x, e.enter(x, { _container: !0 })), x === "listUnordered")
        return e.enter("listItemPrefix"), f === 42 || f === 45 ? e.check(Ce, t, a)(f) : a(f);
      if (!n.interrupt || f === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), l(f);
    }
    return t(f);
  }
  function l(f) {
    return He(f) && ++o < 10 ? (e.consume(f), l) : (!n.interrupt || o < 2) && (n.containerState.marker ? f === n.containerState.marker : f === 41 || f === 46) ? (e.exit("listItemValue"), a(f)) : t(f);
  }
  function a(f) {
    return e.enter("listItemMarker"), e.consume(f), e.exit("listItemMarker"), n.containerState.marker = n.containerState.marker || f, e.check(Ie, n.interrupt ? t : m, e.attempt(ai, p, s));
  }
  function m(f) {
    return n.containerState.initialBlankLine = !0, r++, p(f);
  }
  function s(f) {
    return L(f) ? (e.enter("listItemPrefixWhitespace"), e.consume(f), e.exit("listItemPrefixWhitespace"), p) : t(f);
  }
  function p(f) {
    return n.containerState.size = r + n.sliceSerialize(e.exit("listItemPrefix"), !0).length, i(f);
  }
}
function hi(e, i, t) {
  const n = this;
  return n.containerState._closeFlow = void 0, e.check(Ie, c, r);
  function c(u) {
    return n.containerState.furtherBlankLines = n.containerState.furtherBlankLines || n.containerState.initialBlankLine, M(e, i, "listItemIndent", n.containerState.size + 1)(u);
  }
  function r(u) {
    return n.containerState.furtherBlankLines || !L(u) ? (n.containerState.furtherBlankLines = void 0, n.containerState.initialBlankLine = void 0, o(u)) : (n.containerState.furtherBlankLines = void 0, n.containerState.initialBlankLine = void 0, e.attempt(fi, i, o)(u));
  }
  function o(u) {
    return n.containerState._closeFlow = !0, n.interrupt = void 0, M(e, e.attempt($, i, t), "linePrefix", n.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(u);
  }
}
function mi(e, i, t) {
  const n = this;
  return M(e, c, "listItemIndent", n.containerState.size + 1);
  function c(r) {
    const o = n.events[n.events.length - 1];
    return o && o[1].type === "listItemIndent" && o[2].sliceSerialize(o[1], !0).length === n.containerState.size ? i(r) : t(r);
  }
}
function pi(e) {
  e.exit(this.containerState.type);
}
function gi(e, i, t) {
  const n = this;
  return M(e, c, "listItemPrefixWhitespace", n.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function c(r) {
    const o = n.events[n.events.length - 1];
    return !L(r) && o && o[1].type === "listItemPrefixWhitespace" ? i(r) : t(r);
  }
}
const ot = { name: "setextUnderline", tokenize: xi, resolveTo: ki };
function ki(e, i) {
  let t = e.length, n, c, r;
  for (; t--; )
    if (e[t][0] === "enter") {
      if (e[t][1].type === "content") {
        n = t;
        break;
      }
      e[t][1].type === "paragraph" && (c = t);
    } else
      e[t][1].type === "content" && e.splice(t, 1), !r && e[t][1].type === "definition" && (r = t);
  const o = { type: "setextHeading", start: Object.assign({}, e[c][1].start), end: Object.assign({}, e[e.length - 1][1].end) };
  return e[c][1].type = "setextHeadingText", r ? (e.splice(c, 0, ["enter", o, i]), e.splice(r + 1, 0, ["exit", e[n][1], i]), e[n][1].end = Object.assign({}, e[r][1].end)) : e[n][1] = o, e.push(["exit", o, i]), e;
}
function xi(e, i, t) {
  const n = this;
  let c;
  return r;
  function r(a) {
    let m = n.events.length, s;
    for (; m--; )
      if (n.events[m][1].type !== "lineEnding" && n.events[m][1].type !== "linePrefix" && n.events[m][1].type !== "content") {
        s = n.events[m][1].type === "paragraph";
        break;
      }
    return !n.parser.lazy[n.now().line] && (n.interrupt || s) ? (e.enter("setextHeadingLine"), c = a, o(a)) : t(a);
  }
  function o(a) {
    return e.enter("setextHeadingLineSequence"), u(a);
  }
  function u(a) {
    return a === c ? (e.consume(a), u) : (e.exit("setextHeadingLineSequence"), L(a) ? M(e, l, "lineSuffix")(a) : l(a));
  }
  function l(a) {
    return a === null || I(a) ? (e.exit("setextHeadingLine"), i(a)) : t(a);
  }
}
const bi = { tokenize: yi };
function yi(e) {
  const i = this, t = e.attempt(Ie, n, e.attempt(this.parser.constructs.flowInitial, c, M(e, e.attempt(this.parser.constructs.flow, c, e.attempt(In, c)), "linePrefix")));
  return t;
  function n(r) {
    if (r === null) {
      e.consume(r);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(r), e.exit("lineEndingBlank"), i.currentConstruct = void 0, t;
  }
  function c(r) {
    if (r === null) {
      e.consume(r);
      return;
    }
    return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), i.currentConstruct = void 0, t;
  }
}
const vi = { resolveAll: Tt() }, Si = It("string"), wi = It("text");
function It(e) {
  return { tokenize: i, resolveAll: Tt(e === "text" ? Fi : void 0) };
  function i(t) {
    const n = this, c = this.parser.constructs[e], r = t.attempt(c, o, u);
    return o;
    function o(m) {
      return a(m) ? r(m) : u(m);
    }
    function u(m) {
      if (m === null) {
        t.consume(m);
        return;
      }
      return t.enter("data"), t.consume(m), l;
    }
    function l(m) {
      return a(m) ? (t.exit("data"), r(m)) : (t.consume(m), l);
    }
    function a(m) {
      if (m === null)
        return !0;
      const s = c[m];
      let p = -1;
      if (s)
        for (; ++p < s.length; ) {
          const f = s[p];
          if (!f.previous || f.previous.call(n, n.previous))
            return !0;
        }
      return !1;
    }
  }
}
function Tt(e) {
  return i;
  function i(t, n) {
    let c = -1, r;
    for (; ++c <= t.length; )
      r === void 0 ? t[c] && t[c][1].type === "data" && (r = c, c++) : (!t[c] || t[c][1].type !== "data") && (c !== r + 2 && (t[r][1].end = t[c - 1][1].end, t.splice(r + 2, c - r - 2), c = r + 2), r = void 0);
    return e ? e(t, n) : t;
  }
}
function Fi(e, i) {
  let t = 0;
  for (; ++t <= e.length; )
    if ((t === e.length || e[t][1].type === "lineEnding") && e[t - 1][1].type === "data") {
      const n = e[t - 1][1], c = i.sliceStream(n);
      let r = c.length, o = -1, u = 0, l;
      for (; r--; ) {
        const a = c[r];
        if (typeof a == "string") {
          for (o = a.length; a.charCodeAt(o - 1) === 32; )
            u++, o--;
          if (o)
            break;
          o = -1;
        } else if (a === -2)
          l = !0, u++;
        else if (a !== -1) {
          r++;
          break;
        }
      }
      if (u) {
        const a = { type: t === e.length || l || u < 2 ? "lineSuffix" : "hardBreakTrailing", start: { line: n.end.line, column: n.end.column - u, offset: n.end.offset - u, _index: n.start._index + r, _bufferIndex: r ? o : n.start._bufferIndex + o }, end: Object.assign({}, n.end) };
        n.end = Object.assign({}, a.start), n.start.offset === n.end.offset ? Object.assign(n, a) : (e.splice(t, 0, ["enter", a, i], ["exit", a, i]), t += 2);
      }
      t++;
    }
  return e;
}
function Ii(e, i, t) {
  let n = Object.assign(t ? Object.assign({}, t) : { line: 1, column: 1, offset: 0 }, { _index: 0, _bufferIndex: -1 });
  const c = {}, r = [];
  let o = [], u = [];
  const l = { consume: A, enter: S, exit: E, attempt: _(O), check: _(b), interrupt: _(b, { interrupt: !0 }) }, a = { previous: null, code: null, containerState: {}, events: [], parser: e, sliceStream: f, sliceSerialize: p, now: x, defineSkip: T, write: s };
  let m = i.tokenize.call(a, l);
  return i.resolveAll && r.push(i), a;
  function s(w) {
    return o = G(o, w), C(), o[o.length - 1] !== null ? [] : (V(i, 0), a.events = _e(r, a.events, a), a.events);
  }
  function p(w, F) {
    return zi(f(w), F);
  }
  function f(w) {
    return Ti(o, w);
  }
  function x() {
    const { line: w, column: F, offset: j, _index: B, _bufferIndex: D } = n;
    return { line: w, column: F, offset: j, _index: B, _bufferIndex: D };
  }
  function T(w) {
    c[w.line] = w.column, g();
  }
  function C() {
    let w;
    for (; n._index < o.length; ) {
      const F = o[n._index];
      if (typeof F == "string")
        for (w = n._index, n._bufferIndex < 0 && (n._bufferIndex = 0); n._index === w && n._bufferIndex < F.length; )
          y(F.charCodeAt(n._bufferIndex));
      else
        y(F);
    }
  }
  function y(w) {
    m = m(w);
  }
  function A(w) {
    I(w) ? (n.line++, n.column = 1, n.offset += w === -3 ? 2 : 1, g()) : w !== -1 && (n.column++, n.offset++), n._bufferIndex < 0 ? n._index++ : (n._bufferIndex++, n._bufferIndex === o[n._index].length && (n._bufferIndex = -1, n._index++)), a.previous = w;
  }
  function S(w, F) {
    const j = F || {};
    return j.type = w, j.start = x(), a.events.push(["enter", j, a]), u.push(j), j;
  }
  function E(w) {
    const F = u.pop();
    return F.end = x(), a.events.push(["exit", F, a]), F;
  }
  function O(w, F) {
    V(w, F.from);
  }
  function b(w, F) {
    F.restore();
  }
  function _(w, F) {
    return j;
    function j(B, D, U) {
      let W, J, re, d;
      return Array.isArray(B) ? oe(B) : "tokenize" in B ? oe([B]) : X(B);
      function X(N) {
        return ve;
        function ve(le) {
          const ge = le !== null && N[le], he = le !== null && N.null, Ae = [...Array.isArray(ge) ? ge : ge ? [ge] : [], ...Array.isArray(he) ? he : he ? [he] : []];
          return oe(Ae)(le);
        }
      }
      function oe(N) {
        return W = N, J = 0, N.length === 0 ? U : h(N[J]);
      }
      function h(N) {
        return ve;
        function ve(le) {
          return d = P(), re = N, N.partial || (a.currentConstruct = N), N.name && a.parser.constructs.disable.null.includes(N.name) ? de() : N.tokenize.call(F ? Object.assign(Object.create(a), F) : a, l, ee, de)(le);
        }
      }
      function ee(N) {
        return w(re, d), D;
      }
      function de(N) {
        return d.restore(), ++J < W.length ? h(W[J]) : U;
      }
    }
  }
  function V(w, F) {
    w.resolveAll && !r.includes(w) && r.push(w), w.resolve && Y(a.events, F, a.events.length - F, w.resolve(a.events.slice(F), a)), w.resolveTo && (a.events = w.resolveTo(a.events, a));
  }
  function P() {
    const w = x(), F = a.previous, j = a.currentConstruct, B = a.events.length, D = Array.from(u);
    return { restore: U, from: B };
    function U() {
      n = w, a.previous = F, a.currentConstruct = j, a.events.length = B, u = D, g();
    }
  }
  function g() {
    n.line in c && n.column < 2 && (n.column = c[n.line], n.offset += c[n.line] - 1);
  }
}
function Ti(e, i) {
  const t = i.start._index, n = i.start._bufferIndex, c = i.end._index, r = i.end._bufferIndex;
  let o;
  if (t === c)
    o = [e[t].slice(n, r)];
  else {
    if (o = e.slice(t, c), n > -1) {
      const u = o[0];
      typeof u == "string" ? o[0] = u.slice(n) : o.shift();
    }
    r > 0 && o.push(e[c].slice(0, r));
  }
  return o;
}
function zi(e, i) {
  let t = -1;
  const n = [];
  let c;
  for (; ++t < e.length; ) {
    const r = e[t];
    let o;
    if (typeof r == "string")
      o = r;
    else
      switch (r) {
        case -5: {
          o = "\r";
          break;
        }
        case -4: {
          o = `
`;
          break;
        }
        case -3: {
          o = `\r
`;
          break;
        }
        case -2: {
          o = i ? " " : "	";
          break;
        }
        case -1: {
          if (!i && c)
            continue;
          o = " ";
          break;
        }
        default:
          o = String.fromCharCode(r);
      }
    c = r === -2, n.push(o);
  }
  return n.join("");
}
const Ci = { 42: $, 43: $, 45: $, 48: $, 49: $, 50: $, 51: $, 52: $, 53: $, 54: $, 55: $, 56: $, 57: $, 62: xt }, Ei = { 91: Ln }, Li = { [-2]: Oe, [-1]: Oe, 32: Oe }, Mi = { 35: Pn, 42: Ce, 45: [ot, Ce], 60: qn, 61: ot, 95: Ce, 96: it, 126: it }, _i = { 38: yt, 92: bt }, Di = { [-5]: Pe, [-4]: Pe, [-3]: Pe, 33: ri, 38: yt, 42: qe, 60: [un, $n], 91: ci, 92: [An, bt], 93: We, 95: qe, 96: yn }, Ai = { null: [qe, vi] }, Oi = { null: [42, 95] }, Pi = { null: [] }, ji = Object.freeze(Object.defineProperty({ __proto__: null, attentionMarkers: Oi, contentInitial: Ei, disable: Pi, document: Ci, flow: Mi, flowInitial: Li, insideSpan: Ai, string: _i, text: Di }, Symbol.toStringTag, { value: "Module" }));
function Ri(e) {
  const i = gt([ji, ...(e || {}).extensions || []]), t = { defined: [], lazy: {}, constructs: i, content: n(Xt), document: n(tn), flow: n(bi), string: n(Si), text: n(wi) };
  return t;
  function n(c) {
    return r;
    function r(o) {
      return Ii(t, c, o);
    }
  }
}
function Hi(e) {
  for (; !vt(e); )
    ;
  return e;
}
const ct = /[\0\t\n\r]/g;
function qi() {
  let e = 1, i = "", t = !0, n;
  return c;
  function c(r, o, u) {
    const l = [];
    let a, m, s, p, f;
    for (r = i + (typeof r == "string" ? r.toString() : new TextDecoder(o || void 0).decode(r)), s = 0, i = "", t && (r.charCodeAt(0) === 65279 && s++, t = void 0); s < r.length; ) {
      if (ct.lastIndex = s, a = ct.exec(r), p = a && a.index !== void 0 ? a.index : r.length, f = r.charCodeAt(p), !a) {
        i = r.slice(s);
        break;
      }
      if (f === 10 && s === p && n)
        l.push(-3), n = void 0;
      else
        switch (n && (l.push(-5), n = void 0), s < p && (l.push(r.slice(s, p)), e += p - s), f) {
          case 0: {
            l.push(65533), e++;
            break;
          }
          case 9: {
            for (m = Math.ceil(e / 4) * 4, l.push(-2); e++ < m; )
              l.push(-1);
            break;
          }
          case 10: {
            l.push(-4), e = 1;
            break;
          }
          default:
            n = !0, e = 1;
        }
      s = p + 1;
    }
    return u && (n && l.push(-5), i && l.push(i), l.push(null)), l;
  }
}
const Vi = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function Bi(e) {
  return e.replace(Vi, Wi);
}
function Wi(e, i, t) {
  if (i)
    return i;
  if (t.charCodeAt(0) === 35) {
    const n = t.charCodeAt(1), c = n === 120 || n === 88;
    return kt(t.slice(c ? 2 : 1), c ? 16 : 10);
  }
  return Be(t) || e;
}
const zt = {}.hasOwnProperty;
function Ni(e, i, t) {
  return typeof i != "string" && (t = i, i = void 0), Ui(t)(Hi(Ri(t).document().write(qi()(e, i, !0))));
}
function Ui(e) {
  const i = { transforms: [], canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"], enter: { autolink: r(Ke), autolinkProtocol: P, autolinkEmail: P, atxHeading: r(Qe), blockQuote: r(ge), characterEscape: P, characterReference: P, codeFenced: r(he), codeFencedFenceInfo: o, codeFencedFenceMeta: o, codeIndented: r(he, o), codeText: r(Ae, o), codeTextData: P, data: P, codeFlowValue: P, definition: r(jt), definitionDestinationString: o, definitionLabelString: o, definitionTitleString: o, emphasis: r(Rt), hardBreakEscape: r($e), hardBreakTrailing: r($e), htmlFlow: r(Ze, o), htmlFlowData: P, htmlText: r(Ze, o), htmlTextData: P, image: r(Ht), label: o, link: r(Ke), listItem: r(qt), listItemValue: p, listOrdered: r(Ye, s), listUnordered: r(Ye), paragraph: r(Vt), reference: h, referenceString: o, resourceDestinationString: o, resourceTitleString: o, setextHeading: r(Qe), strong: r(Bt), thematicBreak: r(Nt) }, exit: { atxHeading: l(), atxHeadingSequence: O, autolink: l(), autolinkEmail: le, autolinkProtocol: ve, blockQuote: l(), characterEscapeValue: g, characterReferenceMarkerHexadecimal: de, characterReferenceMarkerNumeric: de, characterReferenceValue: N, codeFenced: l(C), codeFencedFence: T, codeFencedFenceInfo: f, codeFencedFenceMeta: x, codeFlowValue: g, codeIndented: l(y), codeText: l(D), codeTextData: g, data: g, definition: l(), definitionDestinationString: E, definitionLabelString: A, definitionTitleString: S, emphasis: l(), hardBreakEscape: l(F), hardBreakTrailing: l(F), htmlFlow: l(j), htmlFlowData: g, htmlText: l(B), htmlTextData: g, image: l(W), label: re, labelText: J, lineEnding: w, link: l(U), listItem: l(), listOrdered: l(), listUnordered: l(), paragraph: l(), referenceString: ee, resourceDestinationString: d, resourceTitleString: X, resource: oe, setextHeading: l(V), setextHeadingLineSequence: _, setextHeadingText: b, strong: l(), thematicBreak: l() } };
  Ct(i, (e || {}).mdastExtensions || []);
  const t = {};
  return n;
  function n(k) {
    let v = { type: "root", children: [] };
    const z = { stack: [v], tokenStack: [], config: i, enter: u, exit: a, buffer: o, resume: m, data: t }, R = [];
    let q = -1;
    for (; ++q < k.length; )
      if (k[q][1].type === "listOrdered" || k[q][1].type === "listUnordered")
        if (k[q][0] === "enter")
          R.push(q);
        else {
          const ne = R.pop();
          q = c(k, ne, q);
        }
    for (q = -1; ++q < k.length; ) {
      const ne = i[k[q][0]];
      zt.call(ne, k[q][1].type) && ne[k[q][1].type].call(Object.assign({ sliceSerialize: k[q][2].sliceSerialize }, z), k[q][1]);
    }
    if (z.tokenStack.length > 0) {
      const ne = z.tokenStack[z.tokenStack.length - 1];
      (ne[1] || ut).call(z, void 0, ne[0]);
    }
    for (v.position = { start: ae(k.length > 0 ? k[0][1].start : { line: 1, column: 1, offset: 0 }), end: ae(k.length > 0 ? k[k.length - 2][1].end : { line: 1, column: 1, offset: 0 }) }, q = -1; ++q < i.transforms.length; )
      v = i.transforms[q](v) || v;
    return v;
  }
  function c(k, v, z) {
    let R = v - 1, q = -1, ne = !1, ke, ce, Se, we;
    for (; ++R <= z; ) {
      const K = k[R];
      switch (K[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          K[0] === "enter" ? q++ : q--, we = void 0;
          break;
        }
        case "lineEndingBlank": {
          K[0] === "enter" && (ke && !we && !q && !Se && (Se = R), we = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          we = void 0;
      }
      if (!q && K[0] === "enter" && K[1].type === "listItemPrefix" || q === -1 && K[0] === "exit" && (K[1].type === "listUnordered" || K[1].type === "listOrdered")) {
        if (ke) {
          let xe = R;
          for (ce = void 0; xe--; ) {
            const ue = k[xe];
            if (ue[1].type === "lineEnding" || ue[1].type === "lineEndingBlank") {
              if (ue[0] === "exit")
                continue;
              ce && (k[ce][1].type = "lineEndingBlank", ne = !0), ue[1].type = "lineEnding", ce = xe;
            } else if (!(ue[1].type === "linePrefix" || ue[1].type === "blockQuotePrefix" || ue[1].type === "blockQuotePrefixWhitespace" || ue[1].type === "blockQuoteMarker" || ue[1].type === "listItemIndent"))
              break;
          }
          Se && (!ce || Se < ce) && (ke._spread = !0), ke.end = Object.assign({}, ce ? k[ce][1].start : K[1].end), k.splice(ce || R, 0, ["exit", ke, K[2]]), R++, z++;
        }
        if (K[1].type === "listItemPrefix") {
          const xe = { type: "listItem", _spread: !1, start: Object.assign({}, K[1].start), end: void 0 };
          ke = xe, k.splice(R, 0, ["enter", xe, K[2]]), R++, z++, Se = void 0, we = !0;
        }
      }
    }
    return k[v][1]._spread = ne, z;
  }
  function r(k, v) {
    return z;
    function z(R) {
      u.call(this, k(R), R), v && v.call(this, R);
    }
  }
  function o() {
    this.stack.push({ type: "fragment", children: [] });
  }
  function u(k, v, z) {
    this.stack[this.stack.length - 1].children.push(k), this.stack.push(k), this.tokenStack.push([v, z]), k.position = { start: ae(v.start), end: void 0 };
  }
  function l(k) {
    return v;
    function v(z) {
      k && k.call(this, z), a.call(this, z);
    }
  }
  function a(k, v) {
    const z = this.stack.pop(), R = this.tokenStack.pop();
    if (R)
      R[0].type !== k.type && (v ? v.call(this, k, R[0]) : (R[1] || ut).call(this, k, R[0]));
    else
      throw new Error("Cannot close `" + k.type + "` (" + ze({ start: k.start, end: k.end }) + "): it’s not open");
    z.position.end = ae(k.end);
  }
  function m() {
    return Qt(this.stack.pop());
  }
  function s() {
    this.data.expectingFirstListItemValue = !0;
  }
  function p(k) {
    if (this.data.expectingFirstListItemValue) {
      const v = this.stack[this.stack.length - 2];
      v.start = Number.parseInt(this.sliceSerialize(k), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function f() {
    const k = this.resume(), v = this.stack[this.stack.length - 1];
    v.lang = k;
  }
  function x() {
    const k = this.resume(), v = this.stack[this.stack.length - 1];
    v.meta = k;
  }
  function T() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function C() {
    const k = this.resume(), v = this.stack[this.stack.length - 1];
    v.value = k.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function y() {
    const k = this.resume(), v = this.stack[this.stack.length - 1];
    v.value = k.replace(/(\r?\n|\r)$/g, "");
  }
  function A(k) {
    const v = this.resume(), z = this.stack[this.stack.length - 1];
    z.label = v, z.identifier = te(this.sliceSerialize(k)).toLowerCase();
  }
  function S() {
    const k = this.resume(), v = this.stack[this.stack.length - 1];
    v.title = k;
  }
  function E() {
    const k = this.resume(), v = this.stack[this.stack.length - 1];
    v.url = k;
  }
  function O(k) {
    const v = this.stack[this.stack.length - 1];
    if (!v.depth) {
      const z = this.sliceSerialize(k).length;
      v.depth = z;
    }
  }
  function b() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function _(k) {
    const v = this.stack[this.stack.length - 1];
    v.depth = this.sliceSerialize(k).codePointAt(0) === 61 ? 1 : 2;
  }
  function V() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function P(k) {
    const v = this.stack[this.stack.length - 1].children;
    let z = v[v.length - 1];
    (!z || z.type !== "text") && (z = Wt(), z.position = { start: ae(k.start), end: void 0 }, v.push(z)), this.stack.push(z);
  }
  function g(k) {
    const v = this.stack.pop();
    v.value += this.sliceSerialize(k), v.position.end = ae(k.end);
  }
  function w(k) {
    const v = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const z = v.children[v.children.length - 1];
      z.position.end = ae(k.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && i.canContainEols.includes(v.type) && (P.call(this, k), g.call(this, k));
  }
  function F() {
    this.data.atHardBreak = !0;
  }
  function j() {
    const k = this.resume(), v = this.stack[this.stack.length - 1];
    v.value = k;
  }
  function B() {
    const k = this.resume(), v = this.stack[this.stack.length - 1];
    v.value = k;
  }
  function D() {
    const k = this.resume(), v = this.stack[this.stack.length - 1];
    v.value = k;
  }
  function U() {
    const k = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const v = this.data.referenceType || "shortcut";
      k.type += "Reference", k.referenceType = v, delete k.url, delete k.title;
    } else
      delete k.identifier, delete k.label;
    this.data.referenceType = void 0;
  }
  function W() {
    const k = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const v = this.data.referenceType || "shortcut";
      k.type += "Reference", k.referenceType = v, delete k.url, delete k.title;
    } else
      delete k.identifier, delete k.label;
    this.data.referenceType = void 0;
  }
  function J(k) {
    const v = this.sliceSerialize(k), z = this.stack[this.stack.length - 2];
    z.label = Bi(v), z.identifier = te(v).toLowerCase();
  }
  function re() {
    const k = this.stack[this.stack.length - 1], v = this.resume(), z = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, z.type === "link") {
      const R = k.children;
      z.children = R;
    } else
      z.alt = v;
  }
  function d() {
    const k = this.resume(), v = this.stack[this.stack.length - 1];
    v.url = k;
  }
  function X() {
    const k = this.resume(), v = this.stack[this.stack.length - 1];
    v.title = k;
  }
  function oe() {
    this.data.inReference = void 0;
  }
  function h() {
    this.data.referenceType = "collapsed";
  }
  function ee(k) {
    const v = this.resume(), z = this.stack[this.stack.length - 1];
    z.label = v, z.identifier = te(this.sliceSerialize(k)).toLowerCase(), this.data.referenceType = "full";
  }
  function de(k) {
    this.data.characterReferenceType = k.type;
  }
  function N(k) {
    const v = this.sliceSerialize(k), z = this.data.characterReferenceType;
    let R;
    z ? (R = kt(v, z === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : R = Be(v);
    const q = this.stack.pop();
    q.value += R, q.position.end = ae(k.end);
  }
  function ve(k) {
    g.call(this, k);
    const v = this.stack[this.stack.length - 1];
    v.url = this.sliceSerialize(k);
  }
  function le(k) {
    g.call(this, k);
    const v = this.stack[this.stack.length - 1];
    v.url = "mailto:" + this.sliceSerialize(k);
  }
  function ge() {
    return { type: "blockquote", children: [] };
  }
  function he() {
    return { type: "code", lang: null, meta: null, value: "" };
  }
  function Ae() {
    return { type: "inlineCode", value: "" };
  }
  function jt() {
    return { type: "definition", identifier: "", label: null, title: null, url: "" };
  }
  function Rt() {
    return { type: "emphasis", children: [] };
  }
  function Qe() {
    return { type: "heading", depth: 0, children: [] };
  }
  function $e() {
    return { type: "break" };
  }
  function Ze() {
    return { type: "html", value: "" };
  }
  function Ht() {
    return { type: "image", title: null, url: "", alt: null };
  }
  function Ke() {
    return { type: "link", title: null, url: "", children: [] };
  }
  function Ye(k) {
    return { type: "list", ordered: k.type === "listOrdered", start: null, spread: k._spread, children: [] };
  }
  function qt(k) {
    return { type: "listItem", spread: k._spread, checked: null, children: [] };
  }
  function Vt() {
    return { type: "paragraph", children: [] };
  }
  function Bt() {
    return { type: "strong", children: [] };
  }
  function Wt() {
    return { type: "text", value: "" };
  }
  function Nt() {
    return { type: "thematicBreak" };
  }
}
function ae(e) {
  return { line: e.line, column: e.column, offset: e.offset };
}
function Ct(e, i) {
  let t = -1;
  for (; ++t < i.length; ) {
    const n = i[t];
    Array.isArray(n) ? Ct(e, n) : Qi(e, n);
  }
}
function Qi(e, i) {
  let t;
  for (t in i)
    if (zt.call(i, t))
      switch (t) {
        case "canContainEols": {
          const n = i[t];
          n && e[t].push(...n);
          break;
        }
        case "transforms": {
          const n = i[t];
          n && e[t].push(...n);
          break;
        }
        case "enter":
        case "exit": {
          const n = i[t];
          n && Object.assign(e[t], n);
          break;
        }
      }
}
function ut(e, i) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + ze({ start: e.start, end: e.end }) + "): a different token (`" + i.type + "`, " + ze({ start: i.start, end: i.end }) + ") is open") : new Error("Cannot close document, a token (`" + i.type + "`, " + ze({ start: i.start, end: i.end }) + ") is still open");
}
const $i = { tokenize: Xi, partial: !0 }, Et = { tokenize: er, partial: !0 }, Lt = { tokenize: tr, partial: !0 }, Mt = { tokenize: nr, partial: !0 }, Zi = { tokenize: ir, partial: !0 }, st = { tokenize: Gi, previous: _t }, lt = { tokenize: Ji, previous: Dt }, se = { tokenize: Yi, previous: At }, ie = {};
function Ki() {
  return { text: ie };
}
let me = 48;
for (; me < 123; )
  ie[me] = se, me++, me === 58 ? me = 65 : me === 91 && (me = 97);
ie[43] = se, ie[45] = se, ie[46] = se, ie[95] = se, ie[72] = [se, lt], ie[104] = [se, lt], ie[87] = [se, st], ie[119] = [se, st];
function Yi(e, i, t) {
  const n = this;
  let c, r;
  return o;
  function o(s) {
    return !Ve(s) || !At.call(n, n.previous) || Ne(n.events) ? t(s) : (e.enter("literalAutolink"), e.enter("literalAutolinkEmail"), u(s));
  }
  function u(s) {
    return Ve(s) ? (e.consume(s), u) : s === 64 ? (e.consume(s), l) : t(s);
  }
  function l(s) {
    return s === 46 ? e.check(Zi, m, a)(s) : s === 45 || s === 95 || Z(s) ? (r = !0, e.consume(s), l) : m(s);
  }
  function a(s) {
    return e.consume(s), c = !0, l;
  }
  function m(s) {
    return r && c && Q(n.previous) ? (e.exit("literalAutolinkEmail"), e.exit("literalAutolink"), i(s)) : t(s);
  }
}
function Gi(e, i, t) {
  const n = this;
  return c;
  function c(o) {
    return o !== 87 && o !== 119 || !_t.call(n, n.previous) || Ne(n.events) ? t(o) : (e.enter("literalAutolink"), e.enter("literalAutolinkWww"), e.check($i, e.attempt(Et, e.attempt(Lt, r), t), t)(o));
  }
  function r(o) {
    return e.exit("literalAutolinkWww"), e.exit("literalAutolink"), i(o);
  }
}
function Ji(e, i, t) {
  const n = this;
  let c = "", r = !1;
  return o;
  function o(s) {
    return (s === 72 || s === 104) && Dt.call(n, n.previous) && !Ne(n.events) ? (e.enter("literalAutolink"), e.enter("literalAutolinkHttp"), c += String.fromCodePoint(s), e.consume(s), u) : t(s);
  }
  function u(s) {
    if (Q(s) && c.length < 5)
      return c += String.fromCodePoint(s), e.consume(s), u;
    if (s === 58) {
      const p = c.toLowerCase();
      if (p === "http" || p === "https")
        return e.consume(s), l;
    }
    return t(s);
  }
  function l(s) {
    return s === 47 ? (e.consume(s), r ? a : (r = !0, l)) : t(s);
  }
  function a(s) {
    return s === null || Ee(s) || H(s) || pe(s) || Me(s) ? t(s) : e.attempt(Et, e.attempt(Lt, m), t)(s);
  }
  function m(s) {
    return e.exit("literalAutolinkHttp"), e.exit("literalAutolink"), i(s);
  }
}
function Xi(e, i, t) {
  let n = 0;
  return c;
  function c(o) {
    return (o === 87 || o === 119) && n < 3 ? (n++, e.consume(o), c) : o === 46 && n === 3 ? (e.consume(o), r) : t(o);
  }
  function r(o) {
    return o === null ? t(o) : i(o);
  }
}
function er(e, i, t) {
  let n, c, r;
  return o;
  function o(a) {
    return a === 46 || a === 95 ? e.check(Mt, l, u)(a) : a === null || H(a) || pe(a) || a !== 45 && Me(a) ? l(a) : (r = !0, e.consume(a), o);
  }
  function u(a) {
    return a === 95 ? n = !0 : (c = n, n = void 0), e.consume(a), o;
  }
  function l(a) {
    return c || n || !r ? t(a) : i(a);
  }
}
function tr(e, i) {
  let t = 0, n = 0;
  return c;
  function c(o) {
    return o === 40 ? (t++, e.consume(o), c) : o === 41 && n < t ? r(o) : o === 33 || o === 34 || o === 38 || o === 39 || o === 41 || o === 42 || o === 44 || o === 46 || o === 58 || o === 59 || o === 60 || o === 63 || o === 93 || o === 95 || o === 126 ? e.check(Mt, i, r)(o) : o === null || H(o) || pe(o) ? i(o) : (e.consume(o), c);
  }
  function r(o) {
    return o === 41 && n++, e.consume(o), c;
  }
}
function nr(e, i, t) {
  return n;
  function n(u) {
    return u === 33 || u === 34 || u === 39 || u === 41 || u === 42 || u === 44 || u === 46 || u === 58 || u === 59 || u === 63 || u === 95 || u === 126 ? (e.consume(u), n) : u === 38 ? (e.consume(u), r) : u === 93 ? (e.consume(u), c) : u === 60 || u === null || H(u) || pe(u) ? i(u) : t(u);
  }
  function c(u) {
    return u === null || u === 40 || u === 91 || H(u) || pe(u) ? i(u) : n(u);
  }
  function r(u) {
    return Q(u) ? o(u) : t(u);
  }
  function o(u) {
    return u === 59 ? (e.consume(u), n) : Q(u) ? (e.consume(u), o) : t(u);
  }
}
function ir(e, i, t) {
  return n;
  function n(r) {
    return e.consume(r), c;
  }
  function c(r) {
    return Z(r) ? t(r) : i(r);
  }
}
function _t(e) {
  return e === null || e === 40 || e === 42 || e === 95 || e === 91 || e === 93 || e === 126 || H(e);
}
function Dt(e) {
  return !Q(e);
}
function At(e) {
  return !(e === 47 || Ve(e));
}
function Ve(e) {
  return e === 43 || e === 45 || e === 46 || e === 95 || Z(e);
}
function Ne(e) {
  let i = e.length, t = !1;
  for (; i--; ) {
    const n = e[i][1];
    if ((n.type === "labelLink" || n.type === "labelImage") && !n._balanced) {
      t = !0;
      break;
    }
    if (n._gfmAutolinkLiteralWalkedInto) {
      t = !1;
      break;
    }
  }
  return e.length > 0 && !t && (e[e.length - 1][1]._gfmAutolinkLiteralWalkedInto = !0), t;
}
const rr = { tokenize: dr, partial: !0 };
function or() {
  return { document: { 91: { tokenize: lr, continuation: { tokenize: ar }, exit: fr } }, text: { 91: { tokenize: sr }, 93: { add: "after", tokenize: cr, resolveTo: ur } } };
}
function cr(e, i, t) {
  const n = this;
  let c = n.events.length;
  const r = n.parser.gfmFootnotes || (n.parser.gfmFootnotes = []);
  let o;
  for (; c--; ) {
    const l = n.events[c][1];
    if (l.type === "labelImage") {
      o = l;
      break;
    }
    if (l.type === "gfmFootnoteCall" || l.type === "labelLink" || l.type === "label" || l.type === "image" || l.type === "link")
      break;
  }
  return u;
  function u(l) {
    if (!o || !o._balanced)
      return t(l);
    const a = te(n.sliceSerialize({ start: o.end, end: n.now() }));
    return a.codePointAt(0) !== 94 || !r.includes(a.slice(1)) ? t(l) : (e.enter("gfmFootnoteCallLabelMarker"), e.consume(l), e.exit("gfmFootnoteCallLabelMarker"), i(l));
  }
}
function ur(e, i) {
  let t = e.length;
  for (; t--; )
    if (e[t][1].type === "labelImage" && e[t][0] === "enter") {
      e[t][1];
      break;
    }
  e[t + 1][1].type = "data", e[t + 3][1].type = "gfmFootnoteCallLabelMarker";
  const n = { type: "gfmFootnoteCall", start: Object.assign({}, e[t + 3][1].start), end: Object.assign({}, e[e.length - 1][1].end) }, c = { type: "gfmFootnoteCallMarker", start: Object.assign({}, e[t + 3][1].end), end: Object.assign({}, e[t + 3][1].end) };
  c.end.column++, c.end.offset++, c.end._bufferIndex++;
  const r = { type: "gfmFootnoteCallString", start: Object.assign({}, c.end), end: Object.assign({}, e[e.length - 1][1].start) }, o = { type: "chunkString", contentType: "string", start: Object.assign({}, r.start), end: Object.assign({}, r.end) }, u = [e[t + 1], e[t + 2], ["enter", n, i], e[t + 3], e[t + 4], ["enter", c, i], ["exit", c, i], ["enter", r, i], ["enter", o, i], ["exit", o, i], ["exit", r, i], e[e.length - 2], e[e.length - 1], ["exit", n, i]];
  return e.splice(t, e.length - t + 1, ...u), e;
}
function sr(e, i, t) {
  const n = this, c = n.parser.gfmFootnotes || (n.parser.gfmFootnotes = []);
  let r = 0, o;
  return u;
  function u(s) {
    return e.enter("gfmFootnoteCall"), e.enter("gfmFootnoteCallLabelMarker"), e.consume(s), e.exit("gfmFootnoteCallLabelMarker"), l;
  }
  function l(s) {
    return s !== 94 ? t(s) : (e.enter("gfmFootnoteCallMarker"), e.consume(s), e.exit("gfmFootnoteCallMarker"), e.enter("gfmFootnoteCallString"), e.enter("chunkString").contentType = "string", a);
  }
  function a(s) {
    if (r > 999 || s === 93 && !o || s === null || s === 91 || H(s))
      return t(s);
    if (s === 93) {
      e.exit("chunkString");
      const p = e.exit("gfmFootnoteCallString");
      return c.includes(te(n.sliceSerialize(p))) ? (e.enter("gfmFootnoteCallLabelMarker"), e.consume(s), e.exit("gfmFootnoteCallLabelMarker"), e.exit("gfmFootnoteCall"), i) : t(s);
    }
    return H(s) || (o = !0), r++, e.consume(s), s === 92 ? m : a;
  }
  function m(s) {
    return s === 91 || s === 92 || s === 93 ? (e.consume(s), r++, a) : a(s);
  }
}
function lr(e, i, t) {
  const n = this, c = n.parser.gfmFootnotes || (n.parser.gfmFootnotes = []);
  let r, o = 0, u;
  return l;
  function l(x) {
    return e.enter("gfmFootnoteDefinition")._container = !0, e.enter("gfmFootnoteDefinitionLabel"), e.enter("gfmFootnoteDefinitionLabelMarker"), e.consume(x), e.exit("gfmFootnoteDefinitionLabelMarker"), a;
  }
  function a(x) {
    return x === 94 ? (e.enter("gfmFootnoteDefinitionMarker"), e.consume(x), e.exit("gfmFootnoteDefinitionMarker"), e.enter("gfmFootnoteDefinitionLabelString"), e.enter("chunkString").contentType = "string", m) : t(x);
  }
  function m(x) {
    if (o > 999 || x === 93 && !u || x === null || x === 91 || H(x))
      return t(x);
    if (x === 93) {
      e.exit("chunkString");
      const T = e.exit("gfmFootnoteDefinitionLabelString");
      return r = te(n.sliceSerialize(T)), e.enter("gfmFootnoteDefinitionLabelMarker"), e.consume(x), e.exit("gfmFootnoteDefinitionLabelMarker"), e.exit("gfmFootnoteDefinitionLabel"), p;
    }
    return H(x) || (u = !0), o++, e.consume(x), x === 92 ? s : m;
  }
  function s(x) {
    return x === 91 || x === 92 || x === 93 ? (e.consume(x), o++, m) : m(x);
  }
  function p(x) {
    return x === 58 ? (e.enter("definitionMarker"), e.consume(x), e.exit("definitionMarker"), c.includes(r) || c.push(r), M(e, f, "gfmFootnoteDefinitionWhitespace")) : t(x);
  }
  function f(x) {
    return i(x);
  }
}
function ar(e, i, t) {
  return e.check(Ie, i, e.attempt(rr, i, t));
}
function fr(e) {
  e.exit("gfmFootnoteDefinition");
}
function dr(e, i, t) {
  const n = this;
  return M(e, c, "gfmFootnoteDefinitionIndent", 5);
  function c(r) {
    const o = n.events[n.events.length - 1];
    return o && o[1].type === "gfmFootnoteDefinitionIndent" && o[2].sliceSerialize(o[1], !0).length === 4 ? i(r) : t(r);
  }
}
function hr(e) {
  let i = (e || {}).singleTilde;
  const t = { tokenize: c, resolveAll: n };
  return i == null && (i = !0), { text: { 126: t }, insideSpan: { null: [t] }, attentionMarkers: { null: [126] } };
  function n(r, o) {
    let u = -1;
    for (; ++u < r.length; )
      if (r[u][0] === "enter" && r[u][1].type === "strikethroughSequenceTemporary" && r[u][1]._close) {
        let l = u;
        for (; l--; )
          if (r[l][0] === "exit" && r[l][1].type === "strikethroughSequenceTemporary" && r[l][1]._open && r[u][1].end.offset - r[u][1].start.offset === r[l][1].end.offset - r[l][1].start.offset) {
            r[u][1].type = "strikethroughSequence", r[l][1].type = "strikethroughSequence";
            const a = { type: "strikethrough", start: Object.assign({}, r[l][1].start), end: Object.assign({}, r[u][1].end) }, m = { type: "strikethroughText", start: Object.assign({}, r[l][1].end), end: Object.assign({}, r[u][1].start) }, s = [["enter", a, o], ["enter", r[l][1], o], ["exit", r[l][1], o], ["enter", m, o]], p = o.parser.constructs.insideSpan.null;
            p && Y(s, s.length, 0, _e(p, r.slice(l + 1, u), o)), Y(s, s.length, 0, [["exit", m, o], ["enter", r[u][1], o], ["exit", r[u][1], o], ["exit", a, o]]), Y(r, l - 1, u - l + 3, s), u = l + s.length - 2;
            break;
          }
      }
    for (u = -1; ++u < r.length; )
      r[u][1].type === "strikethroughSequenceTemporary" && (r[u][1].type = "data");
    return r;
  }
  function c(r, o, u) {
    const l = this.previous, a = this.events;
    let m = 0;
    return s;
    function s(f) {
      return l === 126 && a[a.length - 1][1].type !== "characterEscape" ? u(f) : (r.enter("strikethroughSequenceTemporary"), p(f));
    }
    function p(f) {
      const x = Le(l);
      if (f === 126)
        return m > 1 ? u(f) : (r.consume(f), m++, p);
      if (m < 2 && !i)
        return u(f);
      const T = r.exit("strikethroughSequenceTemporary"), C = Le(f);
      return T._open = !C || C === 2 && !!x, T._close = !x || x === 2 && !!C, o(f);
    }
  }
}
class mr {
  constructor() {
    this.map = [];
  }
  add(i, t, n) {
    pr(this, i, t, n);
  }
  consume(i) {
    if (this.map.sort(function(r, o) {
      return r[0] - o[0];
    }), this.map.length === 0)
      return;
    let t = this.map.length;
    const n = [];
    for (; t > 0; )
      t -= 1, n.push(i.slice(this.map[t][0] + this.map[t][1]), this.map[t][2]), i.length = this.map[t][0];
    n.push([...i]), i.length = 0;
    let c = n.pop();
    for (; c; )
      i.push(...c), c = n.pop();
    this.map.length = 0;
  }
}
function pr(e, i, t, n) {
  let c = 0;
  if (!(t === 0 && n.length === 0)) {
    for (; c < e.map.length; ) {
      if (e.map[c][0] === i) {
        e.map[c][1] += t, e.map[c][2].push(...n);
        return;
      }
      c += 1;
    }
    e.map.push([i, t, n]);
  }
}
function gr(e, i) {
  let t = !1;
  const n = [];
  for (; i < e.length; ) {
    const c = e[i];
    if (t) {
      if (c[0] === "enter")
        c[1].type === "tableContent" && n.push(e[i + 1][1].type === "tableDelimiterMarker" ? "left" : "none");
      else if (c[1].type === "tableContent") {
        if (e[i - 1][1].type === "tableDelimiterMarker") {
          const r = n.length - 1;
          n[r] = n[r] === "left" ? "center" : "right";
        }
      } else if (c[1].type === "tableDelimiterRow")
        break;
    } else
      c[0] === "enter" && c[1].type === "tableDelimiterRow" && (t = !0);
    i += 1;
  }
  return n;
}
function kr() {
  return { flow: { null: { tokenize: xr, resolveAll: br } } };
}
function xr(e, i, t) {
  const n = this;
  let c = 0, r = 0, o;
  return u;
  function u(g) {
    let w = n.events.length - 1;
    for (; w > -1; ) {
      const B = n.events[w][1].type;
      if (B === "lineEnding" || B === "linePrefix")
        w--;
      else
        break;
    }
    const F = w > -1 ? n.events[w][1].type : null, j = F === "tableHead" || F === "tableRow" ? b : l;
    return j === b && n.parser.lazy[n.now().line] ? t(g) : j(g);
  }
  function l(g) {
    return e.enter("tableHead"), e.enter("tableRow"), a(g);
  }
  function a(g) {
    return g === 124 || (o = !0, r += 1), m(g);
  }
  function m(g) {
    return g === null ? t(g) : I(g) ? r > 1 ? (r = 0, n.interrupt = !0, e.exit("tableRow"), e.enter("lineEnding"), e.consume(g), e.exit("lineEnding"), f) : t(g) : L(g) ? M(e, m, "whitespace")(g) : (r += 1, o && (o = !1, c += 1), g === 124 ? (e.enter("tableCellDivider"), e.consume(g), e.exit("tableCellDivider"), o = !0, m) : (e.enter("data"), s(g)));
  }
  function s(g) {
    return g === null || g === 124 || H(g) ? (e.exit("data"), m(g)) : (e.consume(g), g === 92 ? p : s);
  }
  function p(g) {
    return g === 92 || g === 124 ? (e.consume(g), s) : s(g);
  }
  function f(g) {
    return n.interrupt = !1, n.parser.lazy[n.now().line] ? t(g) : (e.enter("tableDelimiterRow"), o = !1, L(g) ? M(e, x, "linePrefix", n.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(g) : x(g));
  }
  function x(g) {
    return g === 45 || g === 58 ? C(g) : g === 124 ? (o = !0, e.enter("tableCellDivider"), e.consume(g), e.exit("tableCellDivider"), T) : O(g);
  }
  function T(g) {
    return L(g) ? M(e, C, "whitespace")(g) : C(g);
  }
  function C(g) {
    return g === 58 ? (r += 1, o = !0, e.enter("tableDelimiterMarker"), e.consume(g), e.exit("tableDelimiterMarker"), y) : g === 45 ? (r += 1, y(g)) : g === null || I(g) ? E(g) : O(g);
  }
  function y(g) {
    return g === 45 ? (e.enter("tableDelimiterFiller"), A(g)) : O(g);
  }
  function A(g) {
    return g === 45 ? (e.consume(g), A) : g === 58 ? (o = !0, e.exit("tableDelimiterFiller"), e.enter("tableDelimiterMarker"), e.consume(g), e.exit("tableDelimiterMarker"), S) : (e.exit("tableDelimiterFiller"), S(g));
  }
  function S(g) {
    return L(g) ? M(e, E, "whitespace")(g) : E(g);
  }
  function E(g) {
    return g === 124 ? x(g) : g === null || I(g) ? !o || c !== r ? O(g) : (e.exit("tableDelimiterRow"), e.exit("tableHead"), i(g)) : O(g);
  }
  function O(g) {
    return t(g);
  }
  function b(g) {
    return e.enter("tableRow"), _(g);
  }
  function _(g) {
    return g === 124 ? (e.enter("tableCellDivider"), e.consume(g), e.exit("tableCellDivider"), _) : g === null || I(g) ? (e.exit("tableRow"), i(g)) : L(g) ? M(e, _, "whitespace")(g) : (e.enter("data"), V(g));
  }
  function V(g) {
    return g === null || g === 124 || H(g) ? (e.exit("data"), _(g)) : (e.consume(g), g === 92 ? P : V);
  }
  function P(g) {
    return g === 92 || g === 124 ? (e.consume(g), V) : V(g);
  }
}
function br(e, i) {
  let t = -1, n = !0, c = 0, r = [0, 0, 0, 0], o = [0, 0, 0, 0], u = !1, l = 0, a, m, s;
  const p = new mr();
  for (; ++t < e.length; ) {
    const f = e[t], x = f[1];
    f[0] === "enter" ? x.type === "tableHead" ? (u = !1, l !== 0 && (at(p, i, l, a, m), m = void 0, l = 0), a = { type: "table", start: Object.assign({}, x.start), end: Object.assign({}, x.end) }, p.add(t, 0, [["enter", a, i]])) : x.type === "tableRow" || x.type === "tableDelimiterRow" ? (n = !0, s = void 0, r = [0, 0, 0, 0], o = [0, t + 1, 0, 0], u && (u = !1, m = { type: "tableBody", start: Object.assign({}, x.start), end: Object.assign({}, x.end) }, p.add(t, 0, [["enter", m, i]])), c = x.type === "tableDelimiterRow" ? 2 : m ? 3 : 1) : c && (x.type === "data" || x.type === "tableDelimiterMarker" || x.type === "tableDelimiterFiller") ? (n = !1, o[2] === 0 && (r[1] !== 0 && (o[0] = o[1], s = Te(p, i, r, c, void 0, s), r = [0, 0, 0, 0]), o[2] = t)) : x.type === "tableCellDivider" && (n ? n = !1 : (r[1] !== 0 && (o[0] = o[1], s = Te(p, i, r, c, void 0, s)), r = o, o = [r[1], t, 0, 0])) : x.type === "tableHead" ? (u = !0, l = t) : x.type === "tableRow" || x.type === "tableDelimiterRow" ? (l = t, r[1] !== 0 ? (o[0] = o[1], s = Te(p, i, r, c, t, s)) : o[1] !== 0 && (s = Te(p, i, o, c, t, s)), c = 0) : c && (x.type === "data" || x.type === "tableDelimiterMarker" || x.type === "tableDelimiterFiller") && (o[3] = t);
  }
  for (l !== 0 && at(p, i, l, a, m), p.consume(i.events), t = -1; ++t < i.events.length; ) {
    const f = i.events[t];
    f[0] === "enter" && f[1].type === "table" && (f[1]._align = gr(i.events, t));
  }
  return e;
}
function Te(e, i, t, n, c, r) {
  const o = n === 1 ? "tableHeader" : n === 2 ? "tableDelimiter" : "tableData", u = "tableContent";
  t[0] !== 0 && (r.end = Object.assign({}, be(i.events, t[0])), e.add(t[0], 0, [["exit", r, i]]));
  const l = be(i.events, t[1]);
  if (r = { type: o, start: Object.assign({}, l), end: Object.assign({}, l) }, e.add(t[1], 0, [["enter", r, i]]), t[2] !== 0) {
    const a = be(i.events, t[2]), m = be(i.events, t[3]), s = { type: u, start: Object.assign({}, a), end: Object.assign({}, m) };
    if (e.add(t[2], 0, [["enter", s, i]]), n !== 2) {
      const p = i.events[t[2]], f = i.events[t[3]];
      if (p[1].end = Object.assign({}, f[1].end), p[1].type = "chunkText", p[1].contentType = "text", t[3] > t[2] + 1) {
        const x = t[2] + 1, T = t[3] - t[2] - 1;
        e.add(x, T, []);
      }
    }
    e.add(t[3] + 1, 0, [["exit", s, i]]);
  }
  return c !== void 0 && (r.end = Object.assign({}, be(i.events, c)), e.add(c, 0, [["exit", r, i]]), r = void 0), r;
}
function at(e, i, t, n, c) {
  const r = [], o = be(i.events, t);
  c && (c.end = Object.assign({}, o), r.push(["exit", c, i])), n.end = Object.assign({}, o), r.push(["exit", n, i]), e.add(t + 1, 0, r);
}
function be(e, i) {
  const t = e[i], n = t[0] === "enter" ? "start" : "end";
  return t[1][n];
}
const yr = { tokenize: Sr };
function vr() {
  return { text: { 91: yr } };
}
function Sr(e, i, t) {
  const n = this;
  return c;
  function c(l) {
    return n.previous !== null || !n._gfmTasklistFirstContentOfListItem ? t(l) : (e.enter("taskListCheck"), e.enter("taskListCheckMarker"), e.consume(l), e.exit("taskListCheckMarker"), r);
  }
  function r(l) {
    return H(l) ? (e.enter("taskListCheckValueUnchecked"), e.consume(l), e.exit("taskListCheckValueUnchecked"), o) : l === 88 || l === 120 ? (e.enter("taskListCheckValueChecked"), e.consume(l), e.exit("taskListCheckValueChecked"), o) : t(l);
  }
  function o(l) {
    return l === 93 ? (e.enter("taskListCheckMarker"), e.consume(l), e.exit("taskListCheckMarker"), e.exit("taskListCheck"), u) : t(l);
  }
  function u(l) {
    return I(l) ? i(l) : L(l) ? e.check({ tokenize: wr }, i, t)(l) : t(l);
  }
}
function wr(e, i, t) {
  return M(e, n, "whitespace");
  function n(c) {
    return c === null ? t(c) : i(c);
  }
}
function Fr(e) {
  return gt([Ki(), or(), hr(e), kr(), vr()]);
}
function ft(e, i) {
  const t = String(e);
  if (typeof i != "string")
    throw new TypeError("Expected character");
  let n = 0, c = t.indexOf(i);
  for (; c !== -1; )
    n++, c = t.indexOf(i, c + i.length);
  return n;
}
function Ir(e) {
  if (typeof e != "string")
    throw new TypeError("Expected a string");
  return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
const Ue = function(e) {
  if (e == null)
    return Er;
  if (typeof e == "function")
    return De(e);
  if (typeof e == "object")
    return Array.isArray(e) ? Tr(e) : zr(e);
  if (typeof e == "string")
    return Cr(e);
  throw new Error("Expected function, string, or object as test");
};
function Tr(e) {
  const i = [];
  let t = -1;
  for (; ++t < e.length; )
    i[t] = Ue(e[t]);
  return De(n);
  function n(...c) {
    let r = -1;
    for (; ++r < i.length; )
      if (i[r].apply(this, c))
        return !0;
    return !1;
  }
}
function zr(e) {
  const i = e;
  return De(t);
  function t(n) {
    const c = n;
    let r;
    for (r in e)
      if (c[r] !== i[r])
        return !1;
    return !0;
  }
}
function Cr(e) {
  return De(i);
  function i(t) {
    return t && t.type === e;
  }
}
function De(e) {
  return i;
  function i(t, n, c) {
    return !!(Lr(t) && e.call(this, t, typeof n == "number" ? n : void 0, c || void 0));
  }
}
function Er() {
  return !0;
}
function Lr(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const Ot = [], Mr = !0, dt = !1, _r = "skip";
function Dr(e, i, t, n) {
  let c;
  typeof i == "function" && typeof t != "function" ? (n = t, t = i) : c = i;
  const r = Ue(c), o = n ? -1 : 1;
  u(e, void 0, [])();
  function u(l, a, m) {
    const s = l && typeof l == "object" ? l : {};
    if (typeof s.type == "string") {
      const f = typeof s.tagName == "string" ? s.tagName : typeof s.name == "string" ? s.name : void 0;
      Object.defineProperty(p, "name", { value: "node (" + (l.type + (f ? "<" + f + ">" : "")) + ")" });
    }
    return p;
    function p() {
      let f = Ot, x, T, C;
      if ((!i || r(l, a, m[m.length - 1] || void 0)) && (f = Ar(t(l, m)), f[0] === dt))
        return f;
      if ("children" in l && l.children) {
        const y = l;
        if (y.children && f[0] !== _r)
          for (T = (n ? y.children.length : -1) + o, C = m.concat(y); T > -1 && T < y.children.length; ) {
            const A = y.children[T];
            if (x = u(A, T, C)(), x[0] === dt)
              return x;
            T = typeof x[1] == "number" ? x[1] : T + o;
          }
      }
      return f;
    }
  }
}
function Ar(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [Mr, e] : e == null ? Ot : [e];
}
function Or(e, i, t) {
  const n = Ue((t || {}).ignore || []), c = Pr(i);
  let r = -1;
  for (; ++r < c.length; )
    Dr(e, "text", o);
  function o(l, a) {
    let m = -1, s;
    for (; ++m < a.length; ) {
      const p = a[m], f = s ? s.children : void 0;
      if (n(p, f ? f.indexOf(p) : void 0, s))
        return;
      s = p;
    }
    if (s)
      return u(l, a);
  }
  function u(l, a) {
    const m = a[a.length - 1], s = c[r][0], p = c[r][1];
    let f = 0;
    const x = m.children.indexOf(l);
    let T = !1, C = [];
    s.lastIndex = 0;
    let y = s.exec(l.value);
    for (; y; ) {
      const A = y.index, S = { index: y.index, input: y.input, stack: [...a, l] };
      let E = p(...y, S);
      if (typeof E == "string" && (E = E.length > 0 ? { type: "text", value: E } : void 0), E === !1 ? s.lastIndex = A + 1 : (f !== A && C.push({ type: "text", value: l.value.slice(f, A) }), Array.isArray(E) ? C.push(...E) : E && C.push(E), f = A + y[0].length, T = !0), !s.global)
        break;
      y = s.exec(l.value);
    }
    return T ? (f < l.value.length && C.push({ type: "text", value: l.value.slice(f) }), m.children.splice(x, 1, ...C)) : C = [l], x + C.length;
  }
}
function Pr(e) {
  const i = [];
  if (!Array.isArray(e))
    throw new TypeError("Expected find and replace tuple or list of tuples");
  const t = !e[0] || Array.isArray(e[0]) ? e : [e];
  let n = -1;
  for (; ++n < t.length; ) {
    const c = t[n];
    i.push([jr(c[0]), Rr(c[1])]);
  }
  return i;
}
function jr(e) {
  return typeof e == "string" ? new RegExp(Ir(e), "g") : e;
}
function Rr(e) {
  return typeof e == "function" ? e : function() {
    return e;
  };
}
function Hr() {
  return { transforms: [Ur], enter: { literalAutolink: qr, literalAutolinkEmail: je, literalAutolinkHttp: je, literalAutolinkWww: je }, exit: { literalAutolink: Nr, literalAutolinkEmail: Wr, literalAutolinkHttp: Vr, literalAutolinkWww: Br } };
}
function qr(e) {
  this.enter({ type: "link", title: null, url: "", children: [] }, e);
}
function je(e) {
  this.config.enter.autolinkProtocol.call(this, e);
}
function Vr(e) {
  this.config.exit.autolinkProtocol.call(this, e);
}
function Br(e) {
  this.config.exit.data.call(this, e);
  const i = this.stack[this.stack.length - 1];
  ye(i.type === "link"), i.url = "http://" + this.sliceSerialize(e);
}
function Wr(e) {
  this.config.exit.autolinkEmail.call(this, e);
}
function Nr(e) {
  this.exit(e);
}
function Ur(e) {
  Or(e, [[/(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi, Qr], [/([-.\w+]+)@([-\w]+(?:\.[-\w]+)+)/g, $r]], { ignore: ["link", "linkReference"] });
}
function Qr(e, i, t, n, c) {
  let r = "";
  if (!Pt(c) || (/^w/i.test(i) && (t = i + t, i = "", r = "http://"), !Zr(t)))
    return !1;
  const o = Kr(t + n);
  if (!o[0])
    return !1;
  const u = { type: "link", title: null, url: r + i + o[0], children: [{ type: "text", value: i + o[0] }] };
  return o[1] ? [u, { type: "text", value: o[1] }] : u;
}
function $r(e, i, t, n) {
  return !Pt(n, !0) || /[-\d_]$/.test(t) ? !1 : { type: "link", title: null, url: "mailto:" + i + "@" + t, children: [{ type: "text", value: i + "@" + t }] };
}
function Zr(e) {
  const i = e.split(".");
  return !(i.length < 2 || i[i.length - 1] && (/_/.test(i[i.length - 1]) || !/[a-zA-Z\d]/.test(i[i.length - 1])) || i[i.length - 2] && (/_/.test(i[i.length - 2]) || !/[a-zA-Z\d]/.test(i[i.length - 2])));
}
function Kr(e) {
  const i = /[!"&'),.:;<>?\]}]+$/.exec(e);
  if (!i)
    return [e, void 0];
  e = e.slice(0, i.index);
  let t = i[0], n = t.indexOf(")");
  const c = ft(e, "(");
  let r = ft(e, ")");
  for (; n !== -1 && c > r; )
    e += t.slice(0, n + 1), t = t.slice(n + 1), n = t.indexOf(")"), r++;
  return [e, t];
}
function Pt(e, i) {
  const t = e.input.charCodeAt(e.index - 1);
  return (e.index === 0 || pe(t) || Me(t)) && (!i || t !== 47);
}
function Yr() {
  return { enter: { gfmFootnoteDefinition: Gr, gfmFootnoteDefinitionLabelString: Jr, gfmFootnoteCall: to, gfmFootnoteCallString: no }, exit: { gfmFootnoteDefinition: eo, gfmFootnoteDefinitionLabelString: Xr, gfmFootnoteCall: ro, gfmFootnoteCallString: io } };
}
function Gr(e) {
  this.enter({ type: "footnoteDefinition", identifier: "", label: "", children: [] }, e);
}
function Jr() {
  this.buffer();
}
function Xr(e) {
  const i = this.resume(), t = this.stack[this.stack.length - 1];
  ye(t.type === "footnoteDefinition"), t.label = i, t.identifier = te(this.sliceSerialize(e)).toLowerCase();
}
function eo(e) {
  this.exit(e);
}
function to(e) {
  this.enter({ type: "footnoteReference", identifier: "", label: "" }, e);
}
function no() {
  this.buffer();
}
function io(e) {
  const i = this.resume(), t = this.stack[this.stack.length - 1];
  ye(t.type === "footnoteReference"), t.label = i, t.identifier = te(this.sliceSerialize(e)).toLowerCase();
}
function ro(e) {
  this.exit(e);
}
function oo() {
  return { canContainEols: ["delete"], enter: { strikethrough: co }, exit: { strikethrough: uo } };
}
function co(e) {
  this.enter({ type: "delete", children: [] }, e);
}
function uo(e) {
  this.exit(e);
}
function so() {
  return { enter: { table: lo, tableData: ht, tableHeader: ht, tableRow: fo }, exit: { codeText: ho, table: ao, tableData: Re, tableHeader: Re, tableRow: Re } };
}
function lo(e) {
  const i = e._align;
  this.enter({ type: "table", align: i.map(function(t) {
    return t === "none" ? null : t;
  }), children: [] }, e), this.data.inTable = !0;
}
function ao(e) {
  this.exit(e), this.data.inTable = void 0;
}
function fo(e) {
  this.enter({ type: "tableRow", children: [] }, e);
}
function Re(e) {
  this.exit(e);
}
function ht(e) {
  this.enter({ type: "tableCell", children: [] }, e);
}
function ho(e) {
  let i = this.resume();
  this.data.inTable && (i = i.replace(/\\([\\|])/g, mo));
  const t = this.stack[this.stack.length - 1];
  ye(t.type === "inlineCode"), t.value = i, this.exit(e);
}
function mo(e, i) {
  return i === "|" ? i : e;
}
function po() {
  return { exit: { taskListCheckValueChecked: mt, taskListCheckValueUnchecked: mt, paragraph: go } };
}
function mt(e) {
  const i = this.stack[this.stack.length - 2];
  ye(i.type === "listItem"), i.checked = e.type === "taskListCheckValueChecked";
}
function go(e) {
  const i = this.stack[this.stack.length - 2];
  if (i && i.type === "listItem" && typeof i.checked == "boolean") {
    const t = this.stack[this.stack.length - 1];
    ye(t.type === "paragraph");
    const n = t.children[0];
    if (n && n.type === "text") {
      const c = i.children;
      let r = -1, o;
      for (; ++r < c.length; ) {
        const u = c[r];
        if (u.type === "paragraph") {
          o = u;
          break;
        }
      }
      o === t && (n.value = n.value.slice(1), n.value.length === 0 ? t.children.shift() : t.position && n.position && typeof n.position.start.offset == "number" && (n.position.start.column++, n.position.start.offset++, t.position.start = Object.assign({}, n.position.start)));
    }
  }
  this.exit(e);
}
function ko() {
  return [Hr(), Yr(), oo(), so(), po()];
}
const bo = (e) => Ni(e, { extensions: [Fr()], mdastExtensions: [ko()] });
export {
  bo as markdownToMdAST
};
